import React from 'react';
import { debounce } from 'lodash';
import BigNumber from 'bignumber.js';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import axios from 'axios';
import { showToast } from '../../store/actions/toastAction'
import { isMobile } from 'react-device-detect';
import * as OTPAuth from 'otpauth';
// Firebase modular imports

import firebase from '../../store/firebase'
import { initializeApp } from 'firebase/app';
import { getAuth, updateUser } from "firebase/auth";
import { Modal, TextField } from '@material-ui/core';
import CryptoJS from 'crypto-js';

//import TransakSDK from '@transak/transak-sdk';

//import { getDatabase, ref, onValue, off, get } from 'firebase/database';

// Firebase configuration (replace with your actual config)
// const firebaseConfig = {
//   apiKey: 'YOUR_API_KEY',
//   authDomain: 'YOUR_AUTH_DOMAIN',
//   databaseURL: 'YOUR_DATABASE_URL',
//   projectId: 'YOUR_PROJECT_ID',
//   storageBucket: 'YOUR_STORAGE_BUCKET',
//   messagingSenderId: 'YOUR_MESSAGING_SENDER_ID',
//   appId: 'YOUR_APP_ID',
// };

// Initialize Firebase
// let app;
// try {
//   app = initializeApp(firebaseConfig);
// } catch (error) {
// }
//const database = app ? getDatabase(app) : null;

import { FB_URL, SHOW_TOAST } from '../../store/actions/types';
import ReCAPTCHA from 'react-google-recaptcha';
import { checkDuplicateCustodialWallet } from './CheckDuplicateWallet';
import { DomainAddRounded, SwitchAccessShortcutSharp } from '@mui/icons-material';

let cachedCentralTime = null;
let lastFetchMs = 0;
const CACHE_DURATION_MS = 45000; // 45 seconds – adjust as needed

// Material-UI styles
const styles = (theme) => ({
  root: {
    padding: theme.spacing(3),
    textAlign: 'center',
    paddingTop: isMobile ? '10px' : '0px'
  },
  button: {
    minWidth: '100px',
    padding: theme.spacing(1, 3),
  },
progress: {
  height: 12,
  minHeight: 12,
  minWidth: '100%',
  borderRadius: 6,
  backgroundColor: '#e0e0e0',
  '& .MuiLinearProgress-bar': {
    backgroundColor: '#4caf50',
  },
  '@media (max-width: 600px)': {
    height: 14,
    borderRadius: 7,
  },
},
  bigAvatar: {
    margin: 10,
    width: 60,
    height: 60,
    border: `4px solid #eeeeee`,
  },
  cardHeader: {
    padding: 0,
    color: '#ffffff',
    marginTop: '-20px',
    backgroundColor: '#eeeeee',
  },
  title: {
    color: '#000000',
    fontWeight: 600,
    padding: '8px 0px 0px',
  },
  subheader: {
    color: '#000000',
    fontWeight: 600,
    padding: '8px 0px 0px',
  },
  avatar: {
    marginRight: '-20px',
  },
  editprofile: {
    position: 'relative',
    top: '-12px',
    left: '-22px',
    borderRadius: '50%',
    backgroundColor: '#000000',
    padding: '1px',
    cursor: 'pointer',
    color: '#fff',
    '&:hover': {
      background: '#333333',
    },
  },
  chip: {
    height: '16px',
    borderRadius: '50%',
    fontSize: '12px!important',
    cursor: 'pointer',
  },
  followers: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: 'small',
    backgroundColor: '#ffffff',
    padding: '8px 16px!important',
  },
  follow: {
    width: '49.9%',
    textAlign: 'center',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  typfont: {
    color: '#000000',
    cursor: 'pointer',
  },
});

class Mevcoin extends React.Component {
  buyApproved = null; 
 // sellApproved = null; 
  state = {
    progress: 0,
    showProgress: false,
   // buyApproved: null,
    errorMessage: null,
    modalOpen: false,
    modalAOpen: false,
    modalTOpen: false,
    mevAmount: '',
    LcAmount: 0,
    sellApproved: false,
    sendToCustodial: false,
    // TOTP (Google Authenticator) states for MEV Exchange
    isWhatsAppVerified: false, // reused flag: true = TOTP verified for this session
    whatsappOTPRequired: true, // reused flag: true = TOTP gate active
    mevOTPCode: '',
    isVerifyingMevOTP: false,
    totpEnabled: false,
    totpSecret: '',
    userPhoneNumber: null,
    AllowToSell: 0,
    captchaToken: null,
    siteKey: "",
    mevExchangeOn: false
   // userLCReady: 0, // Example value; replace with actual logic
  };


  // SELL Open/close modal/////////////////////////////////////////////////////
  handleOpenModal = async() => {
   const paused = await this.isExchangePaused();
    if (paused) {
      alert("Trading is temporarily paused due to liqudity adjustment. Please try again in 5 minutes.");
      return;
    }
    this.setState({ modalOpen: true });
    if (this.props.userdetails[0].custodialwallet) {
     if (this.props.userdetails[0].custodialwallet.length > 0 && !this.state.sendToCustodial) {
         const params = {
           type: 'SHOW_TOAST',
           open: true,
           variant: 'info',
          message: 'PLEASE NOTE: You have to confirm the checkbox to send your MEV Coin payout to your Custodial Wallet.'
         }
         this.props.showToast(params)      
     }
    }
  };

  handleCloseModal = () => {
    this.setState({ modalOpen: false, mevAmount: '' });
  };

  handleCaptchaChange = (token) => {
    this.setState({ captchaToken: token });
  };

  handleCaptchaExpired = () => {
    this.setState({ captchaToken: null }); // Reset on expiration
  };

  isExchangePaused = async () => {
    try {
      const Ref = firebase.database.ref(`exchangepaused/paused`);
      const snapshot = await Ref.once('value');
      if (snapshot.exists()) {     
        return snapshot.val(); 
      }
      else {
        return false;
      }
    } catch (error) {
      console.error("Error reading exchange pause status:", error);
      return false; // never block trading on error
    }

  };

  setupMEVExchangeListener = () => {
    // Reference to the exact path: patreon/mevExchangeon
    this.patreonRef = firebase
      .database
      .ref('patreon/mevExchangeon');

    this.patreonRef.on(
      'value',
      (snapshot) => {
        const value = snapshot.val();

        // Update state: true if the value is truthy, otherwise false
        this.setState({
          mevExchangeOn: !!value,   // !! ensures boolean (true/false)
        });
      },
      (error) => {
        console.error('Firebase Realtime DB error (patreon/mevExchangeon):', error);
        // Optional: you can set an error state here if you want
      }
    );
  };
  
  // BUY Open/close modal/////////////////////////////////////////////////////
  // Open/close modal
  handleOpenAModal = async() => {
    const paused = await this.isExchangePaused();
    if (paused) {
      alert("Trading is temporarily paused due to liqudity adjustment. Please try again in 5 minutes.");
      return;
    }
    this.setState({ modalAOpen: true });
  };

  handleCloseAModal = () => {
    this.setState({ modalAOpen: false, LcAmount: 0 });
  };

  handleOpenTModal = async() => {
    const paused = await this.isExchangePaused();
    if (paused) {
      alert("Trading is temporarily paused due to liqudity adjustment. Please try again in 5 minutes.");
      return;
    }
    this.setState({ modalTOpen: true });
  };

  handleCloseTModal = () => {
   this.setState({ modalTOpen: false, LcAmount: 0 });
  };
  //////////////////////////////////////////////////////

  // Handle input change
  handleAmountChange = (event) => { //sell coins
    const {AllowToSell} = this.state;
    const sellMEV = event.target.value;
    console.log('max coins to sell: ', AllowToSell);
    console.log('max coins sellMEV: ', sellMEV);
    if (sellMEV < 0) {
      this.setState({ mevAmount: 0});
    }
    else {
    if (sellMEV < AllowToSell) {
      this.setState({ mevAmount: event.target.value });
    }
    else {
      this.setState({ mevAmount: AllowToSell });
    }
   }
  };
////////////////////////////////////////////////////////////////////
handleAmountAChange = (event) => {
  const sellLc = Number(event.target.value);
  this.processSetbuy(sellLc);
};

processSetbuy = async (sellLc) => {
  const {LcAmount} = this.state;
  const myUid = this.props.userdetails[0].uid;
  const livePoints = await this.getLivePoints(myUid);    
    const totLc = Number(livePoints / 100);
    //const sellLc = event.target.value;
    const setLc = totLc - sellLc;

    if (sellLc < 0) {
      this.setState({ LcAmount: 0 });
    }
    else {
    if (setLc > 0) {
      
      this.setState({ LcAmount: sellLc });
    } 
    else {
      //const defLc = totLc - 2.2;
      this.setState({ LcAmount: 0 });
    } 
   };
  }
////////////////////////////////////////////////////////////////////

  // handleAmountAChange = (event) => { //buy coins
  //   const {LcAmount} = this.state;
    
  //   const totLc = Number(this.props.userdetails[0].points / 100);
  //   const sellLc = event.target.value;
  //   const setLc = totLc - sellLc;

  //   if (sellLc < 0) {
  //     this.setState({ LcAmount: 0 });
  //   }
  //   else {
  //   if (setLc > 0) {
      
  //     this.setState({ LcAmount: sellLc });
  //   } 
  //   else {
  //     //const defLc = totLc - 2.2;
  //     this.setState({ LcAmount: 0 });
  //   } 
  //  };
  // }
  
  // Google Authenticator (TOTP) verification for MEV Exchange access
  handleMevTOTPChange = (event) => {
    const value = event.target.value.replace(/\D/g, '').slice(0, 6);
    this.setState({ mevOTPCode: value });
  };

  handleVerifyMevTOTP = async () => {
    const { mevOTPCode, totpSecret, totpEnabled } = this.state;

    if (!totpEnabled || !totpSecret) {
      this.props.showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: '⚠️ Google Authenticator is not configured. Please enable TOTP in your Security settings before using the MEV Exchange.',
      });
      return;
    }

    if (!mevOTPCode || mevOTPCode.length !== 6) {
      this.props.showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Please enter a 6-digit code from Google Authenticator.',
      });
      return;
    }

    try {
      this.setState({ isVerifyingMevOTP: true });

      const totp = new OTPAuth.TOTP({
        issuer: 'ThinkLead',
        label: this.props.userdetails[0]?.email || '',
        algorithm: 'SHA1',
        digits: 6,
        period: 30,
        secret: OTPAuth.Secret.fromBase32(totpSecret)
      });

      const delta = totp.validate({
        token: mevOTPCode,
        window: 1
      });

      this.setState({ isVerifyingMevOTP: false });

      if (delta !== null) {
        this.setState({
          isWhatsAppVerified: true,
          whatsappOTPRequired: false,
          mevOTPCode: ''
        });

        this.props.showToast({
          type: 'SHOW_TOAST',
          open: true,
          variant: 'success',
          message: '✅ Identity verified! You can now access the MEV Exchange.',
        });
      } else {
        this.props.showToast({
          type: 'SHOW_TOAST',
          open: true,
          variant: 'error',
          message: '❌ Invalid code! Please enter the current code from Google Authenticator.',
        });
      }
    } catch (error) {
      this.setState({ isVerifyingMevOTP: false });
      this.props.showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'error',
        message: `❌ Verification failed: ${error.message}`,
      });
    }
  };

  // Handle "Sell MEV" button click in modal
  // handleSellMEV = async () => {
  //   const { mevAmount } = this.state;
  
  //   // Validate input: Check if mevAmount is empty, not a number, or invalid
  //   if (!mevAmount || isNaN(mevAmount) || mevAmount.trim() === '') {
  //     alert('Please enter a valid MEV amount');
  //     return;
  //   }
  
  //   // Convert to BigNumber for precise calculations
  //   let mevAmountBN;
  //   try {
  //     mevAmountBN = new BigNumber(mevAmount);
  //   } catch (error) {
  //     alert('Please enter a valid MEV amount');
  //     return;
  //   }
  
  //   // Check if amount is less than or equal to zero
  //   if (mevAmountBN.lte(0)) {
  //     alert('Please enter a positive MEV amount');
  //     return;
  //   }
  
  //   const uid = this.props.userdetails[0].uid;
  //   const mevInWallet = firebase.database.ref(`/user/${uid}/mevInWallet`);

  //   // Check if transaction is feasible
  //   const canProceed = await this.canPerformMEVSale(mevAmountBN.toString(), mevInWallet);

  //   if (canProceed) {
  //     this.setState({ sellApproved: true });
  //     // Call the original sell handler with the amount
  //     this.handleSellClick(mevAmount);
  //     this.handleCloseModal();
  //   } else {
  //     alert('Transaction cannot proceed due to insufficient BNB or MEV.');
  //   }
  // };

  handleBuyMEV = async () => {
      const { captchaToken, LcAmount } = this.state;
      if (this.props.userdetails[0].custodialwallet==='0x0BD3E677a7E570D4462d295a139FB8Ae05e00578' ||
         this.props.userdetails[0].custodialwallet==='0xbF4030586861798FF8A6a2B3479463Cbda91aa99'  ||
         this.props.userdetails[0].custodialwallet==='0x29eB940e21590896108687E3039Ad124ad139fB7'
       )
      {
          let paramsX = {
            type: SHOW_TOAST,
            open: true,
            variant: 'warning',
            message: 'Your account has a technical issue. Please try another time.'
          }
          this.props.showToast(paramsX);
          return;
      }
      else {
      if (!captchaToken) {
        alert('Please complete the CAPTCHA to prove you are human.');
        return;  // Reject submission
      }   
      this.handleBuyClick(LcAmount);
      this.handleCloseAModal();
      }   
  }

  handleSellMEV = async () => {
   const { captchaToken, mevAmount } = this.state;
    if (window.location.search.includes('exchange_paused=1')) {
      alert("Trading is temporarily paused for transfer of liquidity. This will only take 3 minutes. Please wait...");
      return;
    }

      if (this.props.userdetails[0].custodialwallet==='0x0BD3E677a7E570D4462d295a139FB8Ae05e00578' ||
         this.props.userdetails[0].custodialwallet==='0xbF4030586861798FF8A6a2B3479463Cbda91aa99'  ||
         this.props.userdetails[0].custodialwallet==='0x29eB940e21590896108687E3039Ad124ad139fB7'
       )
      {
          let paramsX = {
            type: SHOW_TOAST,
            open: true,
            variant: 'warning',
            message: 'Your account has a technical issue. Please try another time.'
          }
          this.props.showToast(paramsX)
          return;
      }
   
     if (!captchaToken) {
        alert('Please complete the CAPTCHA to prove you are human.');
        return;  // Reject submission
      }   
    // Validate input: Check if mevAmount is empty, not a number, or invalid
    if (!mevAmount || isNaN(mevAmount) || mevAmount.trim() === '') {
      
      alert('Please enter a valid MEV amount');
      return;
    }
  
  if (this.props.userdetails[0].custodialwallet) {   
if (this.props.userdetails[0].custodialwallet.length > 0 && !this.state.sendToCustodial) {
  const userConfirmed = window.confirm(
    'Are you sure you do NOT want to send your MEV coin payout to your custodial wallet?'
  );
  if (!userConfirmed) {
    alert('Transaction cancelled.');
    return;
  }
 }
}

    // Convert to BigNumber for precise calculations
    let mevAmountBN;
    try {
      mevAmountBN = new BigNumber(mevAmount);
    } catch (error) {
      
      alert('Please enter a valid MEV amount');
      return;
    }
  
    // Check if amount is less than or equal to zero
    if (mevAmountBN.lte(0)) {
      
      alert('Please enter a positive MEV amount');
      return;
    }
  
    // Fetch mevInWallet from Firebase
    const uid = this.props.userdetails[0].uid;
    let mevInWallet;
    try {
      //const mevInWalletRef = firebase.database().ref(`/user/${uid}/mevInWallet`);
      const mevInWalletRef = firebase.database.ref(`/user/${uid}/mevInWallet`);
      const snapshot = await mevInWalletRef.once('value');
      if (!snapshot.exists()) {
        
        alert('Unable to fetch wallet balance');
        return;
      }
      mevInWallet = snapshot.val();
      // Ensure mevInWallet is a valid number
      if (!mevInWallet || isNaN(mevInWallet)) {
        
        alert('Invalid wallet balance data');
        return;
      }
    } catch (error) {
      
      alert('Error fetching wallet balance');
      return;
    }
  
    // Check if transaction is feasible
    const canProceed = await this.canPerformMEVSale(mevAmountBN.toString(), mevInWallet.toString());
  
    if (canProceed) {
      this.setState({ sellApproved: true });
      // Call the original sell handler with the amount
     // this.handleSellClick(mevAmount);
      this.handleSellClick(mevAmountBN.toString());
      this.handleCloseModal();
    } else {
      alert('Transaction cannot proceed due to insufficient BNB or MEV.');
    }
  };

  handleBuyTokens = async () => {
   const { captchaToken, mevAmount } = this.state;
    if (window.location.search.includes('exchange_paused=1')) {
      alert("Trading is temporarily paused for transfer of liquidity. This will only take 3 minutes. Please wait...");
      return;
    }

      if (this.props.userdetails[0].custodialwallet==='0x0BD3E677a7E570D4462d295a139FB8Ae05e00578' ||
         this.props.userdetails[0].custodialwallet==='0xbF4030586861798FF8A6a2B3479463Cbda91aa99'  ||
         this.props.userdetails[0].custodialwallet==='0x29eB940e21590896108687E3039Ad124ad139fB7'
       )
      {
          let paramsX = {
            type: SHOW_TOAST,
            open: true,
            variant: 'warning',
            message: 'Your account has a technical issue. Please try another time.'
          }
          this.props.showToast(paramsX)
          return;
      }
   
     if (!captchaToken) {
        alert('Please complete the CAPTCHA to prove you are human.');
        return;  // Reject submission
      }   
    // Validate input: Check if mevAmount is empty, not a number, or invalid
    if (!mevAmount || isNaN(mevAmount) || mevAmount.trim() === '') {
      
      alert('Please enter a valid MEV amount');
      return;
    }
  
//   if (this.props.userdetails[0].custodialwallet) {   
// if (this.props.userdetails[0].custodialwallet.length > 0 && !this.state.sendToCustodial) {
//   const userConfirmed = window.confirm(
//     'Are you sure you do NOT want to send your MEV coin payout to your custodial wallet?'
//   );
//   if (!userConfirmed) {
//     alert('Transaction cancelled.');
//     return;
//   }
//  }
// }

    // Convert to BigNumber for precise calculations
    let mevAmountBN;
    try {
      mevAmountBN = new BigNumber(mevAmount);
    } catch (error) {
      
      alert('Please enter a valid MEV amount');
      return;
    }
  
    // Check if amount is less than or equal to zero
    if (mevAmountBN.lte(0)) {
      
      alert('Please enter a positive MEV amount');
      return;
    }
  
    // Fetch mevInWallet from Firebase
    const uid = this.props.userdetails[0].uid;
    let mevInWallet;
    try {
      //const mevInWalletRef = firebase.database().ref(`/user/${uid}/mevInWallet`);
      const mevInWalletRef = firebase.database.ref(`/user/${uid}/mevInWallet`);
      const snapshot = await mevInWalletRef.once('value');
      if (!snapshot.exists()) {
        
        alert('Unable to fetch wallet balance');
        return;
      }
      mevInWallet = snapshot.val();
      // Ensure mevInWallet is a valid number
      if (!mevInWallet || isNaN(mevInWallet)) {
        
        alert('Invalid wallet balance data');
        return;
      }
    } catch (error) {
      
      alert('Error fetching wallet balance');
      return;
    }
  
    // Check if transaction is feasible
    const canProceed = await this.canPerformMEVSale(mevAmountBN.toString(), mevInWallet.toString());
  
    if (canProceed) {
      this.setState({ sellApproved: true });
      // Call the original sell handler with the amount
     // this.handleSellClick(mevAmount);
      this.buyTokens(mevAmountBN.toString());
      this.handleCloseTModal();
    } else {
      alert('Transaction cannot proceed due to insufficient BNB or MEV.');
    }
  };

  componentDidMount = async () => {
    var userwalletaddress = this.props.userdetails[0].wallet;
    this.setupMEVExchangeListener();
    ///////////////////////////////////////////////////////////////////////////////
        const dbRef = firebase.database.ref('MEVinfo/AllowToSell');
        dbRef.on('value', (snapshot) => {
          const value = snapshot.val();
          if (value !== null) {
            this.setState({ AllowToSell: Number(value) }); //.toString() 
          }
        }, (error) => {
          
          this.props.showToast({
            type: SHOW_TOAST,
            open: true,
            variant: 'error',
            message: 'Failed to fetch AllowToSell value',
          });
        });
     ///MAKE WALLET IF DOES NOT EXIST////////////////////////////////////////////////////////////////////
      if (userwalletaddress) {
        // wallet already exists
      } else {
      try {        
    ///////////MAKE WALLET/////////////////////
     WalletKeys = await this.MakeWallet();
    ///////////////////////////////////////////
     } catch (error) {       
      // Handle error appropriately
     }
    }
    ///////////////////////////////////////////////////////////////////////
      //GOOGLE CAPTCHA LIVE/TEST
      var siteKey;
      if (process.env.REACT_APP_TYPE_SERVER==='live') {
        siteKey="6Ld8bTAsAAAAAEWDbRX8fTcq4gVD87Do5c1gCyY7";
      }
      else {
        siteKey="6LdwbzAsAAAAADWraCam3NsAIdTTZAo0vJuzSbwn";
      } 
      this.setState({
          siteKey: siteKey
        });   
    ///////////////////////////////////////////////////////////////////////////////
    // Enforce Google Authenticator (TOTP) for MEV operations on all security levels
    try {
      const uid = this.props.userdetails[0]?.uid;
      if (uid) {
        const userRef = firebase.database.ref(`/user/${uid}`);
        const snapshot = await userRef.once('value');
        if (snapshot.exists()) {
          const userData = snapshot.val();
          const hasTOTP = !!userData.totpEnabled && !!userData.totpSecret;
          this.setState({
            isWhatsAppVerified: false,
            whatsappOTPRequired: true,
            totpEnabled: hasTOTP,
            totpSecret: hasTOTP ? userData.totpSecret : ''
          });
        } else {
          this.setState({
            isWhatsAppVerified: false,
            whatsappOTPRequired: true,
            totpEnabled: false,
            totpSecret: ''
          });
        }
      }
    } catch (e) {
      this.setState({
        isWhatsAppVerified: false,
        whatsappOTPRequired: true,
        totpEnabled: false,
        totpSecret: ''
      });
    }

////MAKE WALLET IF DOES NOT EXIST////////////////////////////////////////////////////////////////////
//     if (userwalletaddress) {
//       // wallet already exists
//     } else {
//     try {
//    ///////////MAKE WALLET/////////////////////
//    WalletKeys = await this.MakeWallet();
//    ///////////////////////////////////////////
//   } catch (error) {
//     // Handle error appropriately
//   }
// }
// ///////////////////////////////////////////////////////////////////////
    try {
      localStorage.removeItem("mevProcessCompleted"); // Reset flag on mount
      await this.checkTransactionFeasibility();
      await this.setupMEVNoteListener(); // Set up real-time listener
    } catch (error) {
      
    //  this.setState({ buyApproved: false, errorMessage: error.message });
    }
  };

  // componentWillUnmount() {
  //   const uid = this.props.userdetails[0]?.uid;
  //   if (uid && database) {
  //     const mevNoteRef = ref(database, `/user/${uid}/MEVnote`);
  //     off(mevNoteRef);
  //   }
  // }
  componentWillUnmount() {
    window.removeEventListener('storage', this.syncPauseStatus);
    clearInterval(this.pollInterval);
  }
  setupMEVNoteListener() {
    const uid = this.props.userdetails[0].uid;
    const mevNoteRef = firebase.database.ref(`/user/${uid}/MEVnote`);
    

    mevNoteRef.on(
      "value",
      (snapshot) => {
        const mevNote = snapshot.val();
        

        if (mevNote && mevNote !== "." && mevNote !== ".." ) {
          const hasRefreshed = localStorage.getItem("mevProcessCompleted");
  
          // Map mevNote to progress percentage
          let progressValue = 0;
          let showProgress = true;
  
          switch (mevNote) {
            case "Preparing your MEV purchase...":
              progressValue = 5;
              break;
            case "MEV Purchase Approved":
              progressValue = 8;
              break;
            case "Converting Lc to BNB":
              progressValue = 12;
              break;
            case "Calculating BNB to send to patron wallet":
              progressValue = 18;
              break;
            case "Initial BNB transferred to user wallet":
              progressValue = 22;
              break;
            case "Additional BNB transferred to user wallet":
              progressValue = 28;
              break;
            case "Total BNB transferred to user wallet":
              progressValue = 33;
              break;
            case "BNB transfer to safe wallet successful":
              progressValue = 37;
              break;
            case "Preparing your coin purchase, please wait...":
              progressValue = 40;
              break; 
            case "SUCCESS! MEV coin purchase Successful. Please wait while We finalize details.":
              progressValue = 60;
              break;
            case "Setting rates and MEV coin price.":
              progressValue = 70;
              break;
            case "Almost finished! Updating Database.":
              progressValue = 80;
              break;
            case "PROCESS COMPLETED":
              progressValue = 99;
              break;
            case ".":
              progressValue = 100;
              break;
            //SELL MEV /////////////////////////////////////////////////////////////////////////////////////////
            case "Preparing to sell MEV coins...":
                   progressValue = 5;
                    break;
            case "Checking wallet Ballance":
                    progressValue = 10;
                    break;  
            case "Funded wallet for gas fees":
                    progressValue = 18;
                    break;
            case "Approved MEV tokens for sale":
                    progressValue = 25;
                    break;
            case "Secret committed, waiting for confirmation...":
                    progressValue = 32;
                    break;
            case "Decrypting keys and Generating signature...":
                    progressValue = 44;
                    break
            case "SUCCESS! MEV token sale processed. Transferring coins...":
                    progressValue = 60;
                    break;
            case "MEV Coins transferred to safe wallet":
                   progressValue = 70;
                    break;
            case "BNB payout sent to your wallet":
                   progressValue = 80;
                    break;
            case "Setting rates and MEV coin price...":
                   progressValue = 87;
              break;
            case "Sending Payout Money to Custodial Wallet": 
                progressValue = 92;
              break;
          //BUY TOKENS buyCredits function ///////////////////////////////////////////////////////////////////////   
            case "Preparing to buy tokens":
                progressValue = 5;
                break;
            case "SUCCESS! Token sale processed. Transferring tokens...":
                    progressValue = 60;
                    break;
            case "Authorised Tokens transfered to your account.":
                   progressValue = 80;
                    break;
          //////////////////////////////////////////////////////////////////////////////////
            case "Almost finished! Updating Database. ":
                  progressValue = 95;
              break;
            default:
              if (mevNote.includes("Error")) {
                progressValue = 0; // Reset on error
                showProgress = false; // Hide progress bar on error
              } else {
                progressValue = this.state.progress; // Keep current progress if unknown message
              }
          }
  
          // Update state with progress
         // this.setState({ progress: progressValue, showProgress });
          this.setState({ 
            progress: progressValue,
            mevnote: mevNote,  
            showProgress 
          }, () => {
            
          });


          if (mevNote === "PROCESS COMPLETED" && !hasRefreshed) {
            setTimeout(() => {
            //  window.location.reload();
            }, 2000); // Delay reload to show 100% briefly
            localStorage.setItem("mevProcessCompleted", "true");
          }
  
          // Trigger toast notification
          // let paramsX = {
          //   type: "SHOW_TOAST",
          //   open: true,
          //   variant: mevNote.includes("Error") ? "error" : "success",
          //   message: mevNote,
          // };
          // this.props.showToast(paramsX);
        } else {
          // Hide progress bar if no valid message
          this.setState({ showProgress: false });
        }
      },
      (error) => {
        
        this.setState({ showProgress: false }); // Hide on error
      }
    );
  }

  // async canPerformMEVSale(mevToSell, mevInWallet) {
  //   try {
  //     const userRef = firebase.database.ref('MEVinfo');
  //         const snapshot = await userRef.once('value');

  //     if (!snapshot.exists()) {
  //       return false;
  //     }
  
  //     if ( Number(mevToSell) > Number(mevInWallet) ) {
  //       return false;
  //     }

  //     const mevInfo = snapshot.val();
  //     const { WALLETC, MEVprice, BNB_PRICE_IN_USD } = mevInfo;
  
  //     // Convert values to BigNumber for precise calculations
  //     const bnbAvailable = new BigNumber(WALLETC); // BNB available to pay out
  //     const mevPriceInUSD = new BigNumber(MEVprice); // MEV price in USD
  //     const amountInUSD = new BigNumber(mevToSell).multipliedBy(mevPriceInUSD);//amount of MEV to sell in USD
  //     const transactionAmountUSD = new BigNumber(amountInUSD); // Amount in USD
  //     const BNBPRICEInUSD = BNB_PRICE_IN_USD;
  //     // Step 2: Calculate required BNB and MEV
  //     const requiredBNB = transactionAmountUSD.dividedBy(BNBPRICEInUSD); // BNB needed for the transaction
  //    // const requiredMEV = transactionAmountUSD.dividedBy(mevPriceInUSD); // MEV tokens needed
  
  //     // Step 3: Check if there’s enough BNB in WALLETA
  //     if (bnbAvailable.isLessThan(requiredBNB)) {
  //         `MEV: Insufficient BNB: Available ${bnbAvailable.toString()} BNB, Required ${requiredBNB.toString()} BNB`
  //       );
  //       return false;
  //     }
  
  //     // Step 4: Check if there’s enough MEV in the sale contract
  //     // if (mevAvailable.isLessThan(requiredMEV)) {
  //     //     `MEV: Insufficient MEV: Available ${mevAvailable.toString()} MEV, Required ${requiredMEV.toString()} MEV`
  //     //   );
  //     //   return false;
  //     // }
  
  //     // Step 5: All checks passed
  //       `MEV: Transaction can proceed: ${bnbAvailable.toString()} BNB available (>= ${requiredBNB.toString()}), ${mevAvailable.toString()} MEV available (>= ${requiredMEV.toString()})`
  //     );
  //     return true;
  
  //   } catch (error) {
  //     return false;
  //   }
  // }

  async canPerformMEVSale(mevToSell, mevInWallet) {
    try {
      // Step 1: Validate inputs
      if (!mevToSell || !mevInWallet || isNaN(mevToSell) || isNaN(mevInWallet)) {
        
        return false;
      }
      
      const mevToSellNum = new BigNumber(mevToSell);
      const mevInWalletNum = new BigNumber(mevInWallet);
  
      if (mevToSellNum.lte(0)) {
        
        return false;
      }
      
      // Step 2: Check if user has enough MEV in wallet
      if (mevToSellNum.gt(mevInWalletNum)) {
        
        return false;
      }
      
      // Step 3: Fetch MEVinfo from Firebase Realtime Database
      const userRef = firebase.database.ref('MEVinfo');
      const snapshot = await userRef.once('value');
  
      if (!snapshot.exists()) {
        
        return false;
      }
      
      const mevInfo = snapshot.val();
      const { WALLETC, MEVprice, BNB_PRICE_IN_USD } = mevInfo;
  
    // Step 4: Validate Firebase data
    if (!WALLETC || !MEVprice || !BNB_PRICE_IN_USD || isNaN(WALLETC) || isNaN(MEVprice) || isNaN(BNB_PRICE_IN_USD)) {
      
      return false;
    }
    
      // Step 5: Convert values to BigNumber for precise calculations
      const bnbAvailable = new BigNumber(WALLETC); // BNB available to pay out
      const mevPriceInUSD = new BigNumber(MEVprice); // MEV price in USD
      const amountInUSD = mevToSellNum.multipliedBy(mevPriceInUSD); // Amount of MEV to sell in USD
      const bnbPriceInUSD = new BigNumber(BNB_PRICE_IN_USD);
  
      // Step 6: Calculate required BNB
      const requiredBNB = amountInUSD.dividedBy(bnbPriceInUSD); // BNB needed for the transaction
      
      // Step 7: Check if there’s enough BNB in WALLETC
      if (bnbAvailable.isLessThan(requiredBNB)) {
        
        return false;
      }
      
      // Step 8: All checks passed
      
      return true;
    } catch (error) {
      
      return false;
    }
  }

  async canPerformMEVTransaction(amountInUSD) {
    try {
      // Step 1: Fetch MEVinfo from Firebase Realtime Database
      //const mevInfoRef = ref(db, "MEVinfo");
     // const snapshot = await get(mevInfoRef);

      const userRef = firebase.database.ref('MEVinfo');
          const snapshot = await userRef.once('value');

      if (!snapshot.exists()) {
        
        return false;
      }
  
      const mevInfo = snapshot.val();
      const { MEVav, WALLETA, MEVprice, BNB_PRICE_IN_USD } = mevInfo;
  
      // Convert values to BigNumber for precise calculations
      const mevAvailable = new BigNumber(MEVav); // MEV tokens available
      const bnbAvailable = new BigNumber(WALLETA); // BNB available
      const mevPriceInUSD = new BigNumber(MEVprice); // MEV price in USD
      const transactionAmountUSD = new BigNumber(amountInUSD); // Amount in USD
      const BNBPRICEInUSD = BNB_PRICE_IN_USD;
      // Step 2: Calculate required BNB and MEV
      const requiredBNB = transactionAmountUSD.dividedBy(BNBPRICEInUSD); // BNB needed for the transaction
      const requiredMEV = transactionAmountUSD.dividedBy(mevPriceInUSD); // MEV tokens needed
  
      // Step 3: Check if there’s enough BNB in WALLETA
      if (bnbAvailable.isLessThan(requiredBNB)) {
        
        return false;
      }
  
      // Step 4: Check if there’s enough MEV in the sale contract
      if (mevAvailable.isLessThan(requiredMEV)) {
        
        return false;
      }
  
      // Step 5: All checks passed
      
      return true;
  
    } catch (error) {
      
      return false;
    }
  }

  async checkTransactionFeasibility() {
    const { userdetails } = this.props;
    const userLCReady = parseInt(userdetails[0].points || 1);
    const LcInUSD = Number(userLCReady / 100);
    

    this.buyApproved = await this.canPerformMEVTransaction(LcInUSD); // Assign directly to class property
    
    // Optional: Force a re-render if you need the UI to update immediately
    this.forceUpdate(); // This triggers a re-render without state
  }

  handleBuyClick = debounce((Lc) => {
    this.BuyCoins(Lc);
  }, 3000);

  handleSellClick = debounce((MEVamount) => {
    
    this.SellCoins(MEVamount);
  }, 3000);

  buyTokens = debounce((MEVamount) => {
    
    this.BuyMEVtokens(MEVamount);
  }, 3000);

  BuyCoins = async (Lc) => {
    const userUid = this.props.userdetails[0].uid;
    const custodialwallet = this.props.userdetails[0].custodialwallet;

    const MEVStart = await this.checkAndUpdateMEVbuyStart(this.props.userdetails[0].uid);
   
    const custTemp = '0xbf4030586861798ff8a6a2b3479463cbda91aa99';
    const custTemp2 = '0x0BD3E677a7E570D4462d295a139FB8Ae05e00578';
    const custTemp3 = '0x29eB940e21590896108687E3039Ad124ad139fB7';
    //const useriidd = '14J9UqKM2mdwJEi1cFSJfCPB0qw1';

   //const blocked = await checkDuplicateCustodialWallet(custodialwallet, userUid);
   // const blocked = await checkDuplicateCustodialWallet(custTemp, useriidd);
    var blocked;
    if (custodialwallet===custTemp || custodialwallet===custTemp2 || custodialwallet===custTemp3 ) { 
      blocked = true; 
    }

    if (blocked) {
      let paramsY = {
        type: SHOW_TOAST,
        open: true,
        variant: 'warning',
        message: 'There are data problems with your account. Please contact admin.',
      };
      this.props.showToast(paramsY);

      this.setState({ 
        mevnote: 'Error 665'  
      });
      return;
    }  

    if (MEVStart === true) {
      // let paramsX = {
      //   type: SHOW_TOAST,
      //   open: true,
      //   variant: 'success',
      //   message: 'STARTING your purchase of MEV coins.',
      // };
      // this.props.showToast(paramsX);

      // this.setState({ 
      //   mevnote: 'Initiating your MEV coin purchase...'  
      // });

     

    //const numericValue = Number(this.state.LcAmount);
    const numericValue = Number(Lc);

    if (isNaN(numericValue) || numericValue < 7) {
      let paramsX = {
        type: SHOW_TOAST,
        open: true,
        variant: 'warning',
        message: 'Please select a valid amount of Lc, then try to buy your MEV coins.'
      };
      this.props.showToast(paramsX);
      return;
    }

     if (numericValue > 0) {
      // this.setState({ 
      //   mevnote: 'Initiating your MEV coin purchase...'  
      // });
      // this.handleCloseAModal();
       console.log('mevExchangeOn: ', this.state.mevExchangeOn)
  //    if(this.state.mevExchangeOn===false) {
        if(this.state.mevExchangeOn===true) {
         this.setState({ 
         mevnote: 'Initiating your MEV coin purchase...'  
        });
        await this.BuyMev(Lc); 
       }  
       else {
         const params = {
           type: 'SHOW_TOAST',
           open: true,
           variant: 'info',
           message: 'PLEASE NOTE: The MEV Exchange is off. Thank you for your patience.'
         }
         this.props.showToast(params)   
       }   
     }  
    }
    else{
       //  this.handleCloseAModal();
        let paramsX = {
        type: SHOW_TOAST,
        open: true,
        variant: 'warning',
        message: 'Please wait between 7 and 10 minutes before using the MEV exchange again.'
      }
      this.props.showToast(paramsX)
    }
  };

  SellCoins = async (MEVamount) => {
    const userUid = this.props.userdetails[0].uid;
    const custodialwallet = this.props.userdetails[0].custodialwallet;

    const MEVStart = await this.checkAndUpdateMEVbuyStart(userUid);
   //const MEVStart = true;
    const canSell = await this.deriveAllowToSell(userUid, MEVamount);
   
    const custTemp = '0xbf4030586861798ff8a6a2b3479463cbda91aa99';
    const custTemp2 = '0x0BD3E677a7E570D4462d295a139FB8Ae05e00578';
    const custTemp3 = '0x29eB940e21590896108687E3039Ad124ad139fB7';
    //const useriidd = '14J9UqKM2mdwJEi1cFSJfCPB0qw1';

   //const blocked = await checkDuplicateCustodialWallet(custodialwallet, userUid);
   // const blocked = await checkDuplicateCustodialWallet(custTemp, useriidd);
    var blocked;
    if (custodialwallet===custTemp || custodialwallet===custTemp2 || custodialwallet===custTemp3 ) { 
      blocked = true; 
    }
    //const blocked = await checkDuplicateCustodialWallet(custodialwallet, userUid);
    if (blocked) {
      let paramsY = {
        type: SHOW_TOAST,
        open: true,
        variant: 'warning',
        message: 'There are data problems with your account. Please contact admin.',
      };
      this.props.showToast(paramsY);

      this.setState({ 
        mevnote: 'Error 667'  
      });
      return;
    }
    console.log('deriveAllowToSell F: ',canSell );

     if (canSell===false) {
      let paramsX = {
        type: SHOW_TOAST,
        open: true,
        variant: 'success',
        message: 'You have reached your limits of MEV coins to sell for this month.',
      };
      this.props.showToast(paramsX);
     }
     if (MEVStart === false) {
      let paramsX = {
        type: SHOW_TOAST,
        open: true,
        variant: 'success',
        message: 'Please wait 10 minutes and then try again. Your last transaction attempt was too close to the previous one.',
      };
      this.props.showToast(paramsX);
     }

     if (MEVStart === true && canSell===true) {

      if (this.state.mevExchangeOn===true) {
      // if (0===0) {
          this.setState({ 
            mevnote: 'Preparing to sell MEV coins...'  
          });
          await this.SellMev(MEVamount);
       }  
       else {
         const params = {
           type: 'SHOW_TOAST',
           open: true,
           variant: 'info',
           message: 'PLEASE NOTE: The MEV Exchange is off. Thank you for your patience.'
         }
         this.props.showToast(params)   
       }  

      // this.setState({ 
      //   mevnote: 'Preparing to sell MEV coins...'  
      // });
      // await this.SellMev(MEVamount);
    }
  };

  BuyMEVtokens = async (MEVamount) => {
    const userUid = this.props.userdetails[0].uid;
    const custodialwallet = this.props.userdetails[0].custodialwallet;

    const MEVStart = await this.checkAndUpdateMEVbuyStart(userUid);
   //const MEVStart = true;
    const canSell = await this.deriveAllowToSell(userUid, MEVamount);
   
    const custTemp = '0xbf4030586861798ff8a6a2b3479463cbda91aa99';
    const custTemp2 = '0x0BD3E677a7E570D4462d295a139FB8Ae05e00578';
    const custTemp3 = '0x29eB940e21590896108687E3039Ad124ad139fB7';
    //const useriidd = '14J9UqKM2mdwJEi1cFSJfCPB0qw1';

   //const blocked = await checkDuplicateCustodialWallet(custodialwallet, userUid);
   // const blocked = await checkDuplicateCustodialWallet(custTemp, useriidd);
    var blocked;
    if (custodialwallet===custTemp || custodialwallet===custTemp2 || custodialwallet===custTemp3 ) { 
      blocked = true; 
    }
    //const blocked = await checkDuplicateCustodialWallet(custodialwallet, userUid);
    if (blocked) {
      let paramsY = {
        type: SHOW_TOAST,
        open: true,
        variant: 'warning',
        message: 'There are data problems with your account. Please contact admin.',
      };
      this.props.showToast(paramsY);

      this.setState({ 
        mevnote: 'Error 667'  
      });
      return;
    }
    console.log('deriveAllowToSell F: ',canSell );

     if (canSell===false) {
      let paramsX = {
        type: SHOW_TOAST,
        open: true,
        variant: 'success',
        message: 'You have reached your limits of MEV coins to sell for this month.',
      };
      this.props.showToast(paramsX);
     }
     if (MEVStart === false) {
      let paramsX = {
        type: SHOW_TOAST,
        open: true,
        variant: 'success',
        message: 'Please wait 10 minutes and then try again. Your last transaction attempt was too close to the previous one.',
      };
      this.props.showToast(paramsX);
     }

     if (MEVStart === true && canSell===true) {

      if (this.state.mevExchangeOn===true) {
      // if (0===0) {
          this.setState({ 
            mevnote: 'Preparing to sell MEV coins...'  
          });
          await this.buyCredits(MEVamount);
       }  
       else {
         const params = {
           type: 'SHOW_TOAST',
           open: true,
           variant: 'info',
           message: 'PLEASE NOTE: The MEV Exchange is off. Thank you for your patience.'
         }
         this.props.showToast(params)   
       }  

      // this.setState({ 
      //   mevnote: 'Preparing to sell MEV coins...'  
      // });
      // await this.SellMev(MEVamount);
    }
  };

async getCentralNowMs() {
  const now = Date.now();

  // Return cached value if still fresh
  if (cachedCentralTime !== null && now - lastFetchMs < CACHE_DURATION_MS) {
    return cachedCentralTime;
  }

  try {
    const res = await axios.post(`${FB_URL}/m122-centraltime`, {});

    if (res.data?.success === true) {
      let ms;

      // Prefer timestamp (most reliable)
      if (typeof res.data.timestamp === 'number' && res.data.timestamp > 0) {
        ms = res.data.timestamp;
      }
      // Fallback to iso
      else if (typeof res.data.iso === 'string') {
        ms = new Date(res.data.iso).getTime();
      }

      if (typeof ms === 'number' && ms > 0) {
        cachedCentralTime = ms;
        lastFetchMs = now;
        return ms;
      }
    }
  } catch (err) {
    console.warn("Could not fetch central time", err);
  }

  // Last-resort fallback: client-side SAST approximation
  // (still better than plain Date.now() in most cases)
  const fallback = moment().tz("Africa/Johannesburg").valueOf();
  cachedCentralTime = fallback;
  lastFetchMs = now;
  return fallback;
}

  checkAndUpdateMEVbuyStart = async (uid) => {
    const userRef = firebase.database.ref('user/' + uid);
    var updates = {};
      
      try {
        const snapshot = await userRef.once('value');

        
        // const snapshot = await userRef.once('value');
        if (!snapshot.exists()) {
          
          return false;
        }
        
        const userData = snapshot.val();
        const MEVStart = userData.MEVStart || 0;
        const MEVsession = userData.MEVSession;
        //const now = Date.now();
        const now = await this.getCentralNowMs();

        const minSinceMEVStart = (now - MEVStart) / (1000 * 60); // Convert milliseconds to minutes

        if (MEVsession===false && minSinceMEVStart < 7) {
          return false;
        }

       //Update local state before Firebase to ensure instant changes

        updates['/user/' + uid + '/MEVStart'] = now;
        updates['/user/' + uid + '/MEVSession'] = true;
       // await update(userRef, { pledgeStart: now });
        //await firebase.database.ref().update(updates);

          var res = await axios.post(`${FB_URL}/m115-freshcard`, {
              params: {
                    updates: updates, //user wallet address                       
                }
              })

          if (res.data || res.data.success === true) {
            console.log('checkAndUpdateMEVbuyStart success');               }
          else {
            console.error('checkAndUpdateMEVbuyStart Error');
          };          

        return true;
      } catch (error) {
        
        return false;
      }
    };

    //  initiateFiatSell = (userWalletAddress, fiatCurrency) => {
    //   const transak = new TransakSDK({
    //     apiKey: process.env.REACT_APP_TRANSAK_API_KEY,
    //     environment: 'PRODUCTION',
    //     cryptoCurrencyCode: 'BNB',
    //     fiatCurrencyCode: fiatCurrency, // 'ZAR' or 'USD'
    //     walletAddress: userWalletAddress,
    //     isSell: true,
    //     themeColor: '#YOUR_BRAND_COLOR',
    //   });
    //   transak.init();
    // };

  makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * 
  charactersLength));
    }
    return result;
  }

  encryptPrivateKey = (privateKey) => {
    const passphrase = "Lead54321";
    // Convert the private key to a WordArray (binary format)
    const wordArray = CryptoJS.enc.Hex.parse(privateKey.slice(2)); // Remove the "0x" prefix
    return CryptoJS.AES.encrypt(wordArray, passphrase).toString();
  }
  
  // MakeWallet = async () => {
  //   const userwalletaddress = 'xxx';
  //   const userID = this.props.userdetails[0].userID;
  //   const uid = this.props.userdetails[0].uid;
  //   try {
  //     const res = await axios.post(`${FB_URL}/m107-mywallet`, {
  //       params: {
  //         wallet: userwalletaddress,
  //       },
  //     });

  //     const walletAddress = res.data.NewWalletAddress;
  //     const privateKey = res.data.PrivateKey;
  //     const privateKeyEncrypted = this.encryptPrivateKey(privateKey);

  //     const updates = {};
  //     updates['/user/' + uid + '/wallet'] = walletAddress;
  //     updates['/user/' + uid + '/privateKey'] = privateKeyEncrypted;
  //     updates['/users/' + userID + '/wallet'] = walletAddress;
  //     updates['/users/' + userID + '/privateKey'] = privateKeyEncrypted;


  //     if (!database) {
  //       throw new Error('Firebase database not initialized');
  //     }
  //     try {
  //       await firebase.database.ref().update(updates);
  //      // await update(dbRef, updates);
  //     } catch (dbError) {
  //       throw dbError;
  //     }
  //     return {
  //       NewWalletAddress: walletAddress,
  //       PrivateKey: privateKeyEncrypted,
  //     };
  //   } catch (error) {
  //     return null;
  //   }
  // };

  // MakeWallet = async () => {
  //   const userwalletaddress = 'xxx';
  //   const userID = this.props.userdetails[0].userID;
  //   const uid = this.props.userdetails[0].uid;
  
  //   try {
  //     const res = await axios.post(`${FB_URL}/m107-mywallet`, {
  //       params: {
  //         wallet: userwalletaddress,
  //       },
  //     });
  
  //     const walletAddress = res.data.NewWalletAddress;
  //     const privateKey = res.data.PrivateKey;
  //     const privateKeyEncrypted = this.encryptPrivateKey(privateKey);
  
  //      const updates = {};
  //      updates['/user/' + uid + '/wallet'] = walletAddress;
  //      updates['/user/' + uid + '/privateKey'] = privateKeyEncrypted;
  //      updates['/users/' + userID + '/wallet'] = walletAddress;
  //      updates['/users/' + userID + '/privateKey'] = privateKeyEncrypted;

  
  //     // if (!database) {
  //     //   throw new Error('Firebase database not initialized');
  //     // }
  
  //     //const dbRef = ref(database);
  
  //     try {
  //       await firebase.database.ref().update(updates);
  //      // await update(dbRef, updates);
  //     } catch (dbError) {
  //       throw dbError;
  //     }
  
  //     return {
  //       NewWalletAddress: walletAddress,
  //       PrivateKey: privateKeyEncrypted,
  //     };
  //   } catch (error) {
  //     return null;
  //   }
  // };

  async MakeWallet() { //orriginal function before setTimeOut
    var userwalletaddress = 'xxx';
    const updates = {};
    const userID = this.props.userdetails[0].userID;
    const uid = this.props.userdetails[0].uid;
    const bnbinWallet = this.props.userdetails[0].bnbInWallet;
    const mevinWallet = this.props.userdetails[0].mevInWallet;

    var walletAddress;
    var privateKey;
    var privateKeyEncrypted;

    const canCreateWallet = !bnbinWallet && !mevinWallet;
    console.log('MakeWallet A :', bnbinWallet);
    console.log('MakeWallet B :', mevinWallet);
    console.log('MakeWallet C :', canCreateWallet);

   if (canCreateWallet) {
     console.log('MakeWallet D :', 'INSIDE');
           await axios
           .post(`${FB_URL}/m107-mywallet`, {params: { 
               wallet: userwalletaddress //user wallet address
             } })
           .then(res => {
              // walletData = 'BINGO';
              walletAddress = res.data.NewWalletAddress;
              privateKey = res.data.PrivateKey;
              privateKeyEncrypted = this.encryptPrivateKey(privateKey);

              //'userLC MakeWallet privateKey: ', privateKey);

              // NewWalletAddress: res.data.NewWalletAddress,
              // PrivateKey: res.data.PrivateKey
               
              //    NewWalletAddress: res.data.NewWalletAddress,
              //    PrivateKey: res.data.PrivateKey
              //  });
         ///////////////////////////////////////////////////////////////////////
         
        if (res.data.NewWalletAddress) {

         updates['/user/' + uid + '/wallet'] = res.data.NewWalletAddress;
         updates['/user/' + uid + '/privateKey'] = privateKeyEncrypted;//res.data.PrivateKey;

         updates['/users/' + userID + '/wallet'] = res.data.NewWalletAddress;
         updates['/users/' + userID + '/privateKey'] = privateKeyEncrypted;//res.data.PrivateKey;
    
         var res = axios.post(`${FB_URL}/m115-freshcard`, {
                  params: {
                      updates: updates, //user wallet address                       
                  }
            })

        if (res.data || res.data.success === true) {
          console.log('MakeWallet yes');
        }
        else {
          console.error('handleUpMakeWalletdateMev err:');
        }
        //  firebase.database.ref().update(
        //     updates,
        //     function (error) {
        //       if (error) {
        //       } else {
        //       // return '1oxdf345c3456b5467' + testvar 
        //       return {
        //         NewWalletAddress: walletAddress,
        //         PrivateKey: privateKeyEncrypted
        //       };    
        //       }
        //     })         
            }           
          })
         // return '5oxdf345c3456b5467' + walletData 

         //this.setState({
         // walletAddress: walletAddress
         //})
       
         return {
          NewWalletAddress: walletAddress,
          PrivateKey: privateKeyEncrypted
        };
       }
       else {
        return {
          NewWalletAddress: '',
          PrivateKey: ''
        };
       }
      }

  SendBNBtoExternalExchange = async (BNBAmount, custodialWallet) => { //BNBAmount & custodialWallet must be a string
   try {
      //Validate inputs
      if (typeof BNBAmount !== 'string') {
          throw new Error('BNBAmount must be a string');
      }
      if (typeof custodialWallet !== 'string') {
          throw new Error('custodialWallet must be a string');
      }
      if (!web3.utils.isAddress(custodialWallet)) {
          throw new Error('custodialWallet is not a valid Ethereum/BSC address');
      }
      // Convert BNBAmount to BigNumber (in ether)
      const BNBAmountBN = new BigNumber(BNBAmount);
      if (BNBAmountBN.isNaN() || BNBAmountBN.lte(0)) {
          throw new Error('BNBAmount must be a valid positive number');
      }
      // Subtract gas reserve (0.005 BNB)
      const gasReserveBNB = new BigNumber('0.005');
      const finBNBAmountBN = BNBAmountBN.minus(gasReserveBNB);

      // Check for sufficient funds
      if (finBNBAmountBN.lte(0)) {
          throw new Error(`Insufficient BNB: ${BNBAmount} BNB is less than or equal to gas reserve (0.005 BNB)`);
      }
      // Convert to wei and return as string
      const finBNBAmount = finBNBAmountBN.multipliedBy(new BigNumber('1e18')).integerValue().toString();
    } catch (error) {
      
      throw error;
  }
  var newPayBool = true;
        var timeNow;
        var profile;
        var profile_n = this.props.userdetails[0].userType;
        var points;
        var pledge_pers;
        var userID = this.props.userdetails[0].userID;
        var uid = this.props.userdetails[0].uid;
        var companyID = this.props.userdetails[0].companyID;
        var userwalletaddress = this.props.userdetails[0].wallet;
        var newWallet = false;
        var walletAddress;
        var privateKey;
        var privateKeyEncrypted;
        var WalletKeys;

        timeNow = new Date();
        //  if (newPayBool === true) {
          walletAddress = this.props.userdetails[0].wallet; //STILL HAVE TO TEST IF IT ARRIVES IN TIME
          privateKeyEncrypted = this.props.userdetails[0].privateKey;
          
          if (walletAddress && privateKeyEncrypted) {
             //   if (pledge_pers > 600) {

                    //var semiFinalAmount = pledge_pers - 200; //subtract to accomidate gas fees
                    //var finalAmount = semiFinalAmount / 100;
                    
                    try {
                      const auth = getAuth(); // Firebase Authentication instance

                      const user = auth.currentUser;
                      if (!user) {
                          
                          return;
                      }
                      
                      // Get Firebase ID Token
                      const idToken = await user.getIdToken();
                      
                    // 1=reset MEV price/MEV liquidity; 
                    // 2=move various BNB/MEV; 
                    // 3=Transfer BNB from WALLETA to WALLETB; 
                    // 4=Transfer BNB from WALLETB to WALLETA
                    // 18=Transfer BNB from WALLETB to WALLETC
                    // 5=buyTokens
                    // 6=sellTokens
                    // 7=Transfer BNB from WALLETA to OWNER WALLET
                    // 8=Transfer BNB from OWNER WALLET to anywallet
                    // 9=Transfer BNB and MEV from sale contract to OWNER WALLET
                    // 10=Transfer BNB and MEV from OLD sale contract to OWNER WALLET
                    // 11=set MAX TRANSACTION AMOUNT for sale contract USING TIME DELAY OF 3 HOURS
                    // 12=UPDATE MAX TRANSACTION AMOUNT for sale contract ONLY

                    // 14=UPDATE MIN TRANSACTION AMOUNT ONLY wait   
                    // 15=execute MIN TRANSACTION AMOUNT ONLY
                    // 16=emergencyWithdraw
                    // 17=execute emergencyWithdraw
                    // 19=update WhitelistedSigner
                    // 20=newSafeWalletAddress
                    // 21=Transfer BNB from WALLETA to new whitelisted signer
                    // 22=Transfer BNB from WALLETC to WALLETA
                    // 23=Transfer BNB from WALLETA to any wallet
                    // 24=Transfer BNB from userWallet to any wallet
                      /////////////////////////////////////////
                      

                  const rest = await axios.post(`${FB_URL}/m108-buymevision`, {
                            params: {
                                wallet: walletAddress, //user wallet address
                                //privateKey: this.decryptPrivateKey(privateKeyEncrypted), 
                                privateKeyEncrypted: privateKeyEncrypted,
                                profile: profile,
                                profile_n: profile_n,
                                pledge_pers: pledge_pers,
                                userEmail_trim: this.props.userdetails[0].email,
                                companyName: this.props.userdetails[0].companyName,
                                firstName: this.props.userdetails[0].firstName,
                                lastName: this.props.userdetails[0].lastName,
                                userID: this.props.userdetails[0].userID,
                                uid: this.props.userdetails[0].uid,
                                companyID: this.props.userdetails[0].companyID,
                                amount: 0, //$$ sent to buy coins
                                amountS: 0,//sell MEV tokens
                                func: 0,//24, ////////////////////////////////// <===
                                realpoints: 0,
                                iBB: 28,//28,
                                transBNB: finBNBAmount,//'0.8123', //only for 3, 4, 7, 8, 9 & 10
                                transMEV: '1941.46', //only for 9 & 10
                                newMaxInBNB: 200, // for 11
                                setPrice: 1.4661521810774320470178,//0.1544509231664636047248,  //only for 1
                                transHash: '0xb6a9aa4e7cc2ffd77ac60d921fb13430261fe62e56a7a042bd4397d2058708de', //execute owner function after time delay 12, 15, 17
                                minTrans: "0.00000001", //for 14
                                newSafeWalletAddress: "0xBC29BB00739724Be72E3d0e81bBBe0DCCfe1Ff26", //only for 20
                                withdrawAddress: '', //for 16
                                NEW_WALLET: "0x633Fbb79475344677aDD287AE1474d705535d667",
                                anywallet: custodialWallet,
                                divfact: 0, //circulatingTokenLiquidityFactor
                                deployCode: process.env.REACT_APP_DEPLOYMENTCODE
                              }
                      }, {
                        headers: {
                            Authorization: `Bearer ${idToken}` // 🔒 Send the token in the header
                        }
                      });
                      await new Promise(resolve => setTimeout(resolve, 5000));  
                      
                      

                      // //////////////////////////////////////////////////////////////////////////////////                 
                          // const bnbSentTransactionHash = res.data.bnbSentTransactionHash
                          // const amountOfCoinsPurchased = res.data.amountOfCoinsPurchased
                          // const totalGasFeesInUSD = res.data.totalGasFeesInUSD // Display gas fees in MEV tokens
                          // const mevInWallet = res.data.mevInWallet // Display MEV tokens in user wallet
                          // const mevCoinPriceInUSD = res.data.mevCoinPriceInUSD
                      
                      try {
                        let paramsX = {
                          type: SHOW_TOAST,
                          open: true,
                          variant: 'success',
                          message: 'You have sent ' + amountOfCoinsPurchased + ' MEV coins successfully.'
                        }
                        this.props.showToast(paramsX)
                        //////////////////////////////////////////////////////////////////////////////////
                        await new Promise(resolve => setTimeout(resolve, 3000));  
                        ////////////////////////////////////////////////////////////////////////   
                        //  window.location.reload();
                        ////////////////////////////////////////////////////////////////////////
                      } catch (error) {
                        
                      }

                    } catch (error) {
                        

                    }
               // }
            }
       }

  BuyMev = async (Lc) => {
      const { captchaToken } = this.state;
      const updates = {};
      var userLC;
      var fullLc;
      var leftoverLc;
      //userLC = parseInt(this.props.userdetails[0].points || 1); // only points and not calf points because calf alone could be more than 2, and it remains after rollover
      const myUid = this.props.userdetails[0].uid;
      var Lpoints = await this.getLivePoints(myUid); //live points
      var tokens = await this.getLiveTokens(myUid); 
      fullLc = Lpoints;//this.props.userdetails[0].points;
      userLC = Number(Lc) * 100;
      leftoverLc = fullLc - userLC;
      
      console.log('leftoverLc', leftoverLc);

     // this.handleCloseAModal();

      if (userLC > 600) {
     //if (userLC > 60000000000) {
          var newPayBool = true;
          var timeNow;
          var profile;
          var profile_n = this.props.userdetails[0].userType;
          var points;
          var pledge_pers;
          var userID = this.props.userdetails[0].userID;
          var uid = this.props.userdetails[0].uid;
          var companyID = this.props.userdetails[0].companyID;
          var userwalletaddress = this.props.userdetails[0].wallet;
          var newWallet = false;
          var walletAddress;
          var privateKey;
          var privateKeyEncrypted;
          var WalletKeys;
  
         // timeNow = new Date();
          // GET SERVER TIME (UNHACKABLE)
          // const db = firebase.database;
          // const offsetRef = db.ref('.info/serverTimeOffset');
          // const snap = await offsetRef.once('value');
          // const offset = snap.val() || 0;
          // timeNow = new Date(Date.now() + offset);
 
        try {
          const ress = await axios.post(`${FB_URL}/m122-centraltime`, {});

          if (ress.data?.success === true && typeof ress.data.timestamp === 'number') {
            timeNow = new Date(ress.data.timestamp);
            // Optional: verify it's recent
            const ageMs = Date.now() - timeNow.getTime();
            if (Math.abs(ageMs) > 30000) { // more than 30 seconds old → suspicious
              console.warn("Central time seems stale", ageMs);
            }
          } else {
            console.warn("Failed to get central time", ress.data);
            // Fallback strategy: use moment locally (less secure but better than nothing)
            timeNow = moment().tz("Africa/Johannesburg").toDate();
          }
        } catch (err) {
          console.error("Central time fetch failed:", err);
          // Fallback
          timeNow = moment().tz("Africa/Johannesburg").toDate();
        }          
                  
          if (profile_n === 8 || profile_n === "8" || profile_n === '8') {
              profile_n = 3;
              profile = 'Public Contributor';
          } else {
              profile_n = this.props.userdetails[0].userType;
              profile = this.props.userdetails[0].userDescription;
          }
          
  
          if (newPayBool === true) {
              pledge_pers = userLC;           
  
              if (userwalletaddress) {
                  // wallet already exists
                  newWallet = false;
              } else {
                 // await this.MakeWallet();
                  newWallet = true;
                 // let WalletKeys = [];
                  try {
                   ///////////MAKE WALLET/////////////////////
                   WalletKeys = await this.MakeWallet();
                   ///////////////////////////////////////////

                  } catch (error) {
                    
                    // Handle error appropriately
                  }                
  
                  if (WalletKeys) {
   
                    walletAddress = WalletKeys.NewWalletAddress;
                    privateKeyEncrypted = WalletKeys.PrivateKey;
                
                    
                  } else {
                    
                  }
  
              }
              
            if (newWallet===false) {
              walletAddress = this.props.userdetails[0].wallet; //STILL HAVE TO TEST IF IT ARRIVES IN TIME
              privateKeyEncrypted = this.props.userdetails[0].privateKey;
              
  
            }
              if (walletAddress && privateKeyEncrypted && (newWallet = true)) {
                  if (pledge_pers > 600) {
                    
  
                      var semiFinalAmount = pledge_pers - 300; //subtract to accomidate gas fees

                      // var finalAmount = (Number(semiFinalAmount) / 100);
                      var finalAmount = semiFinalAmount / 100;
                
                      console.log('buymev finalAmount', semiFinalAmount);
                      console.log('buymev leftoverLc', leftoverLc);
                      console.log('buymev tot', (pledge_pers + leftoverLc));
                      console.log('buymev fullLc', (fullLc));

                      var buy_sell;

                      if (fullLc === leftoverLc) {
                        buy_sell = false;
                      }
                      else{
                        buy_sell = true;
                      }

                      try {
                        const auth = getAuth(); // Firebase Authentication instance
  
                        const user = auth.currentUser;
                        if (!user) {
                            
                            return;
                        }
                        
                        // Get Firebase ID Token
                        const idToken = await user.getIdToken();
                        
                      // 1=reset MEV price/MEV liquidity; 
                      // 2=move various BNB/MEV; 
                      // 3=Transfer BNB from WALLETA to WALLETB; 
                      // 4=Transfer BNB from WALLETB to WALLETA
                      // 18=Transfer BNB from WALLETB to WALLETC
                      // 5=buyTokens
                      // 6=sellTokens
                      // 7=Transfer BNB from WALLETA to OWNER WALLET
                      // 8=Transfer BNB from OWNER WALLET to anywallet
                      // 9=Transfer BNB and MEV from sale contract to OWNER WALLET
                      // 10=Transfer BNB and MEV from OLD sale contract to OWNER WALLET
                      // 11=set MAX TRANSACTION AMOUNT for sale contract USING TIME DELAY OF 3 HOURS
                      // 12=UPDATE MAX TRANSACTION AMOUNT for sale contract ONLY
  
                      // 14=UPDATE MIN TRANSACTION AMOUNT ONLY wait   
                      // 15=execute MIN TRANSACTION AMOUNT ONLY
                      // 16=emergencyWithdraw
                      // 17=execute emergencyWithdraw
                      // 19=update WhitelistedSigner
                      // 20=newSafeWalletAddress
                      // 21=Transfer BNB from WALLETA to new whitelisted signer
                      // 22=Transfer BNB from WALLETC to WALLETA
                      // 23=Transfer BNB from WALLETA to any wallet
                      // 24=Transfer BNB from userWallet to any wallet
                        /////////////////////////////////
                        //const buy_sell = false;//////////
                        /////////////////////////////////
         
                        let res;

                        //buy_sell = false;
                        if (buy_sell===true) {
                        //only BUY and SELL tokens//////////////////////////////////////////////////////
                        res = await axios.post(`${FB_URL}/m108-buymevision`, {
                       //  const res = await axios.post(`http://localhost:8597/m108-buymevision`, {
                              params: {
                                  wallet: walletAddress, //user wallet address
                                 // privateKey: this.decryptPrivateKey(privateKeyEncrypted), 
                                  privateKeyEncrypted: privateKeyEncrypted,
                                  profile: profile,
                                  profile_n: profile_n,
                                  pledge_pers: pledge_pers,
                                  userEmail_trim: this.props.userdetails[0].email,
                                  companyName: this.props.userdetails[0].companyName,
                                  firstName: this.props.userdetails[0].firstName,
                                  lastName: this.props.userdetails[0].lastName,
                                  userID: this.props.userdetails[0].userID,
                                  uid: this.props.userdetails[0].uid,
                                  companyID: this.props.userdetails[0].companyID,
                                  amount: finalAmount, //$$ sent to buy coins
                                  amountS: 0,//sell MEV tokens
                                  func: 5,// 6 - sell tokens / 5 - buy tokens
                                  realpoints: 0,
                                  tokens: tokens,
                                  leftoverLc: leftoverLc,
                                  iBB: 28,//28,
                                  transBNB: 0.2,
                                  transMEV: 0, 
                                  setPrice: 0,
                                  sendToCustodial: false,
                                  custodialwallet: "",
                                  divfact: 0, //circulatingTokenLiquidityFactor - deviding factor that determines how MEV in circulation is considered by liquidity
                                  deployCode: process.env.REACT_APP_DEPLOYMENTCODE,
                                  captchaToken: captchaToken,
                              }
                          //});
                        }, {
                          headers: {
                              Authorization: `Bearer ${idToken}` // 🔒 Send the token in the header
                          }
                        });
                         
                    /////////////////////////////////////////////////////////////////////////////
                      }
                      else
                      {
                    
                       res = await axios.post(`${FB_URL}/m108-buymevision`, {
                             params: {
                                 wallet: walletAddress, //user wallet address
                                 //privateKey: this.decryptPrivateKey(privateKeyEncrypted), 
                                 privateKeyEncrypted: privateKeyEncrypted,
                                 profile: profile,
                                 profile_n: profile_n,
                                 pledge_pers: pledge_pers,
                                 userEmail_trim: this.props.userdetails[0].email,
                                 companyName: this.props.userdetails[0].companyName,
                                 firstName: this.props.userdetails[0].firstName,
                                 lastName: this.props.userdetails[0].lastName,
                                 userID: this.props.userdetails[0].userID,
                                 uid: this.props.userdetails[0].uid,
                                 companyID: this.props.userdetails[0].companyID,
                                 amount: 0, //$$ sent to buy coins
                                 amountS: 0,//sell MEV tokens
                                   func: 0,//23, ////////////////////////////////// <===
                                 realpoints: 0,
                                 tokens: tokens,
                                 iBB: 28,//28,
                                   transBNB: '7.864450742',//'0.8123', //only for 3, 4, 7, 8, 9 & 10
                                 transMEV: '1941.46', //only for 9 & 10
                                 newMaxInBNB: 200, // for 11
                                 setPrice: 1.4661521810774320470178,//0.1544509231664636047248,  //only for 1
                                 transHash: '0xb6a9aa4e7cc2ffd77ac60d921fb13430261fe62e56a7a042bd4397d2058708de', //execute owner function after time delay 12, 15, 17
                                 minTrans: "0.00000001", //for 14
                                 newSafeWalletAddress: "0xBC29BB00739724Be72E3d0e81bBBe0DCCfe1Ff26", //only for 20
                                 withdrawAddress: '', //for 16
                                 NEW_WALLET: "0x633Fbb79475344677aDD287AE1474d705535d667",
                                   anywallet: "0x6f3889e390D99558B2a272f462d6dbcB24F0A220", 
                                 sendToCustodial: false,
                                 custodialwallet: "",
                                 divfact: 0, //circulatingTokenLiquidityFactor
                                 deployCode: process.env.REACT_APP_DEPLOYMENTCODE,
                                 captchaToken: captchaToken,
                                }
                         //});
                       }, {
                         headers: {
                             Authorization: `Bearer ${idToken}` // 🔒 Send the token in the header
                         }
                       });
                       
                        
                      }
                       ///////////////////////////////////////////////////////////////////////
                         
                          // Reset the loading state to false after the process is complete
                         // this.setState({ isBuying: false });
                        // //////////////////////////////////////////////////////////////////////////////////                 
                            const bnbSentTransactionHash = res.data.bnbSentTransactionHash
                            const amountOfCoinsPurchased = res.data.amountOfCoinsPurchased
                            const totalGasFeesInUSD = res.data.totalGasFeesInUSD // Display gas fees in MEV tokens
                            const mevInWallet = res.data.mevInWallet // Display MEV tokens in user wallet
                            const mevCoinPriceInUSD = res.data.mevCoinPriceInUSD
                       
                        //   profile = profile;
                        //   profile_n = profile_n;
                        //   points = (1 - totalGasFeesInUSD) * 100; //+ parseInt(this.props.userdetails[0].pointsCalf || 0);
  
                        //   const getPatData = {
                        //       profile_n: profile_n,
                        //       profile: profile,
                        //       points: points,
                        //       pledge_pers: pledge_pers,
                        //       userPoints: parseInt(this.props.userdetails[0].pointsCalf || 0),
                        //       userEmail_trim: this.props.userdetails[0].email
                        //   };
  
                        //   var trailID = this.makeid(10);
                        //   var MEVID = this.makeid(10);
                        //   var now = new Date();
                        //   var isoString = now.toISOString();
  
                        //   updates['/users/' + userID + '/userDescription'] = profile;
                        //   updates['/users/' + userID + '/userType'] = profile_n;
                        //   updates['/users/' + userID + '/companyID_userType'] = companyID + '_' + profile_n.toString();
                        //   updates['/users/' + userID + '/points'] = points;
                        //   if (mevInWallet) {
                        //       updates['/users/' + userID + '/mevInWallet'] = mevInWallet;
                        //   }
                        //   if (this.state.PrivateKey && newWallet===true) { //IF WALLET WAS CREATED NOW
                        //       updates['/users/' + userID + '/wallet'] = walletAddress;
                        //       updates['/users/' + userID + '/privateKey'] = privateKeyEncrypted;//this.state.PrivateKey;
                        //   }
  
                        //   updates['/user/' + uid + '/userDescription'] = profile;
                        //   updates['/user/' + uid + '/userType'] = profile_n;
                        //   updates['/user/' + uid + '/companyID_userType'] = companyID + '_' + profile_n.toString();
                        //   updates['/user/' + uid + '/points'] = points;
                        //   updates['/user/' + uid + '/roleoverMoment'] = timeNow;
                        //   if (mevInWallet) {
                        //       updates['/user/' + uid + '/mevInWallet'] = mevInWallet;
                        //       //updates['/user/' + uid + '/roleoverMoment'] = timeNow;
                        //   }
                        //   if (this.state.PrivateKey && newWallet===true) { //IF WALLET WAS CREATED NOW
                        //       updates['/user/' + uid + '/wallet'] = walletAddress;
                        //       updates['/user/' + uid + '/privateKey'] = privateKeyEncrypted;//this.state.PrivateKey;
                        //   }
  
                        //   updates['/pointsTrail/' + trailID] = {
                        //       userID: userID,
                        //       fdate: timeNow,
                        //       trailID: trailID,
                        //       companyName: this.props.userdetails[0].companyName,
                        //       firstName: this.props.userdetails[0].firstName,
                        //       lastName: this.props.userdetails[0].lastName,
                        //       title: 'MEV coins purchased',
                        //       actionType: amountOfCoinsPurchased ? amountOfCoinsPurchased + ' MEV coins purchased.' : 'no purchase',
                        //       actionDesc: amountOfCoinsPurchased ? amountOfCoinsPurchased + ' MEV coins purchased.' : 'no purchase',
                        //       actionType: 'MEV coins purchased',
                        //       actionDesc: 'MEV coins purchased',
                        //       MevInWallet: mevInWallet
                        //   };
  
                        //   updates['/MEV/' + MEVID] = {
                        //       price: mevCoinPriceInUSD,
                        //       time: isoString
                        //   };
  
                        //   var ddd = {
                        //       userID: userID,
                        //       fdate: timeNow.getMonth(),
                        //       trailID: trailID,
                        //       companyName: this.props.userdetails[0].companyName,
                        //       firstName: this.props.userdetails[0].firstName,
                        //       lastName: this.props.userdetails[0].lastName,
                        //       title: 'Pledge converted',
                        //       actionType: 'Pledge converted to LC',
                        //       actionDesc: 'Pledge converted to LC',
                        //       MevInWallet: mevInWallet,
                        //       price: mevCoinPriceInUSD,
                        //       time: isoString
                        //   };
  
  
                        //   await firebase.database.ref().update(updates);
                        // try {
                        //   let paramsX = {
                        //     type: SHOW_TOAST,
                        //     open: true,
                        //     variant: 'success',
                        //     message: 'You have purchased ' + amountOfCoinsPurchased + ' MEV coins successfully.'
                        //   }
                        //   this.props.showToast(paramsX)
                        //   //////////////////////////////////////////////////////////////////////////////////
                        //   await new Promise(resolve => setTimeout(resolve, 3000));  
                        //   ////////////////////////////////////////////////////////////////////////   
                        //    window.location.reload();
                        //   ////////////////////////////////////////////////////////////////////////
                        // } catch (error) {
                        //   //this.setState({ isBuying: false });
                        // }

                          ////////////////////////////////////////////////////////////////////////   
                          //  window.location.reload();
                          ////////////////////////////////////////////////////////////////////////
                    
                      } catch (error) {
                          
                         // this.setState({ isBuying: false });
                         // Reset the loading state to false if an error occurs
                          //this.setState({ isBuying: false });
                      }
                  }
              }
          }
      }
    }

async deriveAllowToSell(uid, MEVsell) {
  const userRef = firebase.database.ref(`user/${uid}`);

  console.log('deriveAllowToSell 1: ', uid);

  try {
    const snapshot = await userRef.once('value');
    const userData = snapshot.val();

    if (!userData) {
      throw new Error('User data not found', MEVsell);
    }

    console.log('deriveAllowToSell 2: ');
    let { mevSold = 0, mevSoldDate, mevInWallet = 0 } = userData;

    // ── Get central SAST time from your endpoint ───────────────────────────────
    let serverNow; // will become a proper Date object
     console.log('deriveAllowToSell 3: ');

    try {
      const res = await axios.post(`${FB_URL}/m122-centraltime`, {});

      if (res.data?.success !== true) {
        console.log("deriveAllowToSell Failed to fetch central time: success flag missing/false");
        return false;
      }
      console.log('deriveAllowToSell 4: ');
      const { timestamp, iso, fdate } = res.data;

      if (typeof timestamp === 'number' && timestamp > 0) {
        // Best & most reliable option
        serverNow = new Date(timestamp);
      } else if (typeof iso === 'string' && iso) {
        // Fallback to ISO string
        serverNow = new Date(iso);
      } else if (typeof fdate === 'string' && fdate) {
        // Last resort: parse "YYYY-MM-DD HH:mm" manually
        const [datePart, timePart] = fdate.split(' ');
        const [year, month, day] = datePart.split('-').map(Number);
        const [hour, minute] = timePart.split(':').map(Number);
        serverNow = new Date(year, month - 1, day, hour, minute, 0);
      } else {
        throw new Error('No usable time field returned from centraltime');
      }

      // Safety check
      if (isNaN(serverNow.getTime())) {
        throw new Error('Parsed central time is invalid');
      }

      console.log('deriveAllowToSell Central SAST time fetched:', serverNow.toISOString());
    } catch (fetchErr) {
      console.error("deriveAllowToSell Failed to fetch / parse central time:", fetchErr);
      return false;
    }

    // Use local getters (SAST month/year)
    const currentMonth = serverNow.getMonth();     // 0–11
    const currentYear  = serverNow.getFullYear();

    console.log('deriveAllowToSell currentMonth:', currentMonth);

    let resetNeeded = false;

    if (mevSoldDate) {
      const soldDate = new Date(mevSoldDate);

      if (isNaN(soldDate.getTime())) {
        resetNeeded = true;
      } else {
        const soldMonth = soldDate.getMonth();
        const soldYear  = soldDate.getFullYear();

        console.log('deriveAllowToSell soldMonth:', soldMonth);

        if (soldMonth !== currentMonth || soldYear !== currentYear) {
          resetNeeded = true;
        }
      }
    } else {
      resetNeeded = true;
    }

    if (resetNeeded) {
      mevSold = 0;

      // Store newSoldDate consistently — choose ONE style:
      // Option A: ISO string (UTC, standard for storage)
      const newSoldDate = serverNow.toISOString();

      // Option B: same format as fdate (local SAST string)
      // const newSoldDate = res.data.fdate;

      // Option C: timestamp number
      // const newSoldDate = res.data.timestamp;

      console.log('deriveAllowToSell 5 - resetting with:', newSoldDate);

      const updates = {};
      updates[`/user/${uid}/mevSold`] = 0;
      updates[`/user/${uid}/mevSoldDate`] = newSoldDate;

      try {
        const ress = await axios.post(`${FB_URL}/m115-freshcard`, {
          params: { updates }
        });

        if (ress.data?.success === true) {
          console.log('Successfully reset mevSold & mevSoldDate');
        } else {
          console.warn('Reset update returned non-success:', ress.data);
          // You can decide whether to proceed or fail here
        }
      } catch (updateErr) {
        console.error('Failed to update via m115-freshcard:', updateErr);
        // Decide policy: continue with old mevSold or return false?
      }
    }

    // Final allowance check
    const AllowToSell = this.state.AllowToSell;

    // Defensive: make sure it's a number
    const maxAllowed = Number(AllowToSell) || 0;

    const totMevToSell = Number(mevSold) + Number(MEVsell);
    const canSell = totMevToSell <= maxAllowed;

    return canSell;

  } catch (error) {
    console.error("deriveAllowToSell error:", error);
    return false;
  }
}

// async deriveAllowToSell_Feb18(uid, MEVsell) {
//   const db = firebase.database;
//   const userRef = db.ref(`user/${uid}`); // Fixed path: `user` → `users`
  
//    console.log('deriveAllowToSell 1: ');
//   try {
//     const snapshot = await userRef.once('value');
//     const userData = snapshot.val();

//     if (!userData) {
//       throw new Error('User data not found');
//     }
//    console.log('deriveAllowToSell 2: ');
//     let { mevSold = 0, mevSoldDate, mevInWallet = 0 } = userData;

//     // === CRITICAL: Use a server timestamp to get current time ===
//     const serverTimeRef = db.ref('.info/serverTimeOffset');
//     const timeSnapshot = await serverTimeRef.once('value');
//     const offset = timeSnapshot.val() || 0;
//     const serverNow = new Date(Date.now() + offset); // This is server time!

    
//     const currentMonth = serverNow.getUTCMonth();
//     const currentYear = serverNow.getUTCFullYear();

//     console.log('deriveAllowToSell currentMonth: ', currentMonth);
//     let resetNeeded = false;

//     if (mevSoldDate) {
//       const soldDate = new Date(mevSoldDate);
//       if (isNaN(soldDate.getTime())) {
//         resetNeeded = true;
//       } else {
//         const soldMonth = soldDate.getUTCMonth();
//         const soldYear = soldDate.getUTCFullYear();
//         console.log('deriveAllowToSell soldMonth: ', soldMonth);
//         if (soldMonth !== currentMonth || soldYear !== currentYear) {
//           resetNeeded = true;
//         }
//       }
//     } else {
//       resetNeeded = true;
//     }

//     if (resetNeeded) {
//       mevSold = 0;
//       const newSoldDate = serverNow.toISOString();
//      console.log('deriveAllowToSell 5: ', newSoldDate);
//       await userRef.update({
//         mevSold: 0,
//         mevSoldDate: newSoldDate,
//       });
//     }

//     // === Calculate AllowToSell (10% of wallet) ===
//    // const AllowToSell = mevInWallet * 0.10; // Don't use this.state here!
//     const AllowToSell = this.state.AllowToSell;

//     const totMevToSell = Number(mevSold) + Number(MEVsell);
//     const canSell = totMevToSell <= AllowToSell; // Use <= to be strict

//     return canSell;

//   } catch (error) {
//     console.error("deriveAllowToSell error:", error);
//     return false;
//   }
// }

    async deriveAllowToSell_Nov12_backup(uid, MEVsell) {
      const db = firebase.database;
      const userRef = db.ref(`user/${uid}`);
    
      try {
        // Fetch user data
        const snapshot = await userRef.once('value');
        const userData = snapshot.val();
    
        if (!userData) {
          throw new Error('User data not found');
          return false;
        }
    
        let { mevSold, mevSoldDate, mevInWallet } = userData;
    
        // Ensure fields are defined, default to 0 for numeric fields
        mevSold = mevSold || 0;
        mevInWallet = mevInWallet || 0;
    
        // Get current date and month (in UTC)
        const currentDate = new Date();
        const currentMonth = currentDate.getUTCMonth();
        const currentYear = currentDate.getUTCFullYear();
    
        // Check if mevSoldDate is from a different month
        let resetNeeded = false;
        if (mevSoldDate) {
          const soldDate = new Date(mevSoldDate);
          if (isNaN(soldDate.getTime())) {
            // Invalid date, treat as reset case
            resetNeeded = true;
          } else {
            const soldMonth = soldDate.getUTCMonth();
            const soldYear = soldDate.getUTCFullYear();
            if (soldMonth !== currentMonth || soldYear !== currentYear) {
              resetNeeded = true;
            }
          }
        } else {
          // If mevSoldDate is undefined, treat as reset case
          resetNeeded = true;
        }
    
        // Reset mevSold and mevSoldDate if needed
        if (resetNeeded) {
          mevSold = 0;
          mevSoldDate = currentDate.toISOString();
    
          // Update the database with new values
          await userRef.update({
            mevSold: 0,
            mevSoldDate: mevSoldDate,
          });
        }
    
        // Calculate AllowToSell (10% of mevInWallet)
        const AllowToSell = this.state.AllowToSell; //25;//mevInWallet * 0.10;
    
        // Determine if user is allowed to sell

        const totMevToSell = Number(mevSold) + Number(MEVsell);
        const canSell = totMevToSell < AllowToSell;
    
        return canSell;
      } catch (error) {
        
        throw error; // Or return false depending on your error handling
      }
    }

async getLivePoints(uid) {
  const db = firebase.database;
  const userRef = db.ref(`user/${uid}`);
  
  try {
    const snapshot = await userRef.once('value');
    const userData = snapshot.val();
    return userData.points || 0; // Fallback to 0 if points is null/undefined
  } catch (error) {
    console.log('getLivePoints Error: ', error);
    return 0; // Or throw error, or fallback to props
  }
}

async getLiveTokens(uid) {
  const db = firebase.database;
  const userRef = db.ref(`user/${uid}`);
  
  try {
    const snapshot = await userRef.once('value');
    const userData = snapshot.val();
    return userData.tokens || 0; // Fallback to 0 if points is null/undefined
  } catch (error) {
    console.log('getLivePoints Error: ', error);
    return 0; // Or throw error, or fallback to props
  }
}

  SellMev = async (MEVamount) => {
    const { captchaToken, AllowToSell } = this.state;

      const updates = {};
      var userLC;
      const myUid = this.props.userdetails[0].uid;
      var points = await this.getLivePoints(myUid); //this.props.userdetails[0].points;
      var tokens = await this.getLiveTokens(myUid); 
         console.log('Test-points S:', points);
   
      //Set session flag to prevent further execution
      var enoughPoints = points / 100;
      
      userLC = MEVamount;//parseInt(this.props.userdetails[0].points || 1); // only points and not calf points because calf alone could be more than 2, and it remains after rollover      

      if ((userLC < AllowToSell) && (enoughPoints > 2) && (userLC > 0)) {
          var newPayBool = true;
          var timeNow;
          var profile;
          var profile_n = this.props.userdetails[0].userType;
          var pledge_pers;
          var userID = this.props.userdetails[0].userID;
          var uid = this.props.userdetails[0].uid;
          var companyID = this.props.userdetails[0].companyID;
          var userwalletaddress = this.props.userdetails[0].wallet;
          var newWallet = false;
          var walletAddress;
          var privateKey;
          var privateKeyEncrypted;
          var WalletKeys;
  
         // timeNow = new Date();
         // GET SERVER TIME (UNHACKABLE)
          // const db = firebase.database;
          // const offsetRef = db.ref('.info/serverTimeOffset');
          // const snap = await offsetRef.once('value');
          // const offset = snap.val() || 0;
          // timeNow = new Date(Date.now() + offset);
         try {
          const ress = await axios.post(`${FB_URL}/m122-centraltime`, {});

          if (ress.data?.success === true && typeof ress.data.timestamp === 'number') {
            timeNow = new Date(res.data.timestamp);
            // Optional: verify it's recent
            const ageMs = Date.now() - timeNow.getTime();
            if (Math.abs(ageMs) > 30000) { // more than 30 seconds old → suspicious
              console.warn("Central time seems stale", ageMs);
            }
          } else {
            console.warn("Failed to get central time", ress.data);
            // Fallback strategy: use moment locally (less secure but better than nothing)
            timeNow = moment().tz("Africa/Johannesburg").toDate();
          }
          } catch (err) {
            console.error("Central time fetch failed:", err);
            // Fallback
            timeNow = moment().tz("Africa/Johannesburg").toDate();
          }            

          if (profile_n === 8 || profile_n === "8" || profile_n === '8') {
              profile_n = 3;
              profile = 'Public Contributor';
          } else {
              profile_n = this.props.userdetails[0].userType;
              profile = this.props.userdetails[0].userDescription;
          }
          
  
          if (newPayBool === true) {
              pledge_pers = userLC;
              
              if (userwalletaddress) {
                  // wallet already exists
                  newWallet = false;
              } else {
                  newWallet = true;
                  try {
                    ///////////MAKE WALLET/////////////////////
                    WalletKeys = await this.MakeWallet();
                    ///////////////////////////////////////////
                  } catch (error) {
                    
                    // Handle error appropriately
                  }
  
                  if (WalletKeys) {
    
                    walletAddress = WalletKeys.NewWalletAddress;
                    privateKeyEncrypted = WalletKeys.PrivateKey;
    
                    
                  } else {
                    
                  }
  
              }
              
            if (newWallet===false) {
              walletAddress = this.props.userdetails[0].wallet; //STILL HAVE TO TEST IF IT ARRIVES IN TIME
              privateKeyEncrypted = this.props.userdetails[0].privateKey;
              
  
            }

              if (walletAddress && privateKeyEncrypted && (newWallet = true)) {

                
                  if (pledge_pers < AllowToSell) {
                  
                      var semiFinalAmount = pledge_pers;// - 200; //subtract to accomidate gas fees
                      // var finalAmount = (Number(semiFinalAmount) / 100);
                      var finalAmount = semiFinalAmount;//semiFinalAmount / 100;
                      var finalPoints = (points - 200) / 100;

                    console.log('Test-points A:', pledge_pers);
                    console.log('Test-points B:', points);
                    console.log('Test-points C:', finalPoints);

                      try {
                        const auth = getAuth(); // Firebase Authentication instance
  
                        const user = auth.currentUser;
                        if (!user) {
                            
                            return;
                        }

                        // Get Firebase ID Token
                        const idToken = await user.getIdToken();
                        
                      // 1=reset MEV price/MEV liquidity; 
                      // 2=move various BNB/MEV; 
                      // 3=Transfer BNB from WALLETA to WALLETB; 
                      // 4=Transfer BNB from WALLETB to WALLETA
                      // 18=Transfer BNB from WALLETB to WALLETC
                      // 5=buyTokens
                      // 6=sellTokens
                      // 7=Transfer BNB from WALLETA to OWNER WALLET
                      // 8=Transfer BNB from OWNER WALLET to anywallet
                      // 9=Transfer BNB and MEV from sale contract to OWNER WALLET
                      // 10=Transfer BNB and MEV from OLD sale contract to OWNER WALLET
                      // 11=set MAX TRANSACTION AMOUNT for sale contract USING TIME DELAY OF 3 HOURS
                      // 12=UPDATE MAX TRANSACTION AMOUNT for sale contract ONLY
  
                      // 14=UPDATE MIN TRANSACTION AMOUNT ONLY wait   
                      // 15=execute MIN TRANSACTION AMOUNT ONLY
                      // 16=emergencyWithdraw
                      // 17=execute emergencyWithdraw
                      // 19=update WhitelistedSigner
                      // 20=newSafeWalletAddress
                      // 21=Transfer BNB from WALLETA to new whitelisted signer
                      // 22=Transfer BNB from WALLETC to WALLETA
                      // 23=Transfer BNB from WALLETA to any wallet
                      // 24=Transfer BNB from userWallet to any wallet
                        /////////////////////////////////////////
                        const buy_sell = true;//////////
                        /////////////////////////////////
                        let res;
                        if (buy_sell===true) {
                        //only BUY and SELL tokens//////////////////////////////////////////////////////
                        res = await axios.post(`${FB_URL}/m108-buymevision`, {
                        //  const res = await axios.post(`http://localhost:8597/m108-buymevision`, {
                              params: {
                                  wallet: walletAddress, //user wallet address
                                 // privateKey: this.decryptPrivateKey(privateKeyEncrypted), 
                                  privateKeyEncrypted: privateKeyEncrypted,
                                  profile: profile,
                                  profile_n: profile_n,
                                  pledge_pers: pledge_pers,
                                  userEmail_trim: this.props.userdetails[0].email,
                                  companyName: this.props.userdetails[0].companyName,
                                  firstName: this.props.userdetails[0].firstName,
                                  lastName: this.props.userdetails[0].lastName,
                                  userID: this.props.userdetails[0].userID,
                                  uid: this.props.userdetails[0].uid,
                                  companyID: this.props.userdetails[0].companyID,
                                  amount: 0, //$$ sent to buy coins
                                  amountS: finalAmount,//sell MEV tokens
                                  func: 6,// 6 - sell tokens / 5 - buy tokens
                                  iBB: 28,//28,
                                  realpoints: finalPoints,
                                  tokens: tokens,
                                  leftoverLc: 0,
                                  transBNB: 0.2,
                                  transMEV: 0, 
                                  setPrice: 0,
                                  sendToCustodial: this.state.sendToCustodial,
                                  custodialwallet: this.props.userdetails[0].custodialwallet,
                                  divfact: 0, //circulatingTokenLiquidityFactor - deviding factor that determines how MEV in circulation is considered by liquidity
                                  deployCode: process.env.REACT_APP_DEPLOYMENTCODE,
                                  captchaToken: captchaToken,
                                }
                          //});
                        }, {
                          headers: {
                              Authorization: `Bearer ${idToken}` // 🔒 Send the token in the header
                          }
                        });
                          
                         //send BNB to custodialwallet if option was selected
                        
                        // if (this.state.sendToCustodial===true) {
                        //  const bnbInWallet = this.props.userdetails[0].bnbInWallet;
                        //  const custodialwallet = this.props.userdetails[0].custodialwallet;
                        //  await new Promise(resolve => setTimeout(resolve, 5000));  
                        //  await this.SendBNBtoExternalExchange(bnbInWallet, custodialwallet);
                       
                        // }
                    /////////////////////////////////////////////////////////////////////////////
                      }
                      else
                      {

                    res = await axios.post(`${FB_URL}/m108-buymevision`, {
                              params: {
                                  wallet: walletAddress, //user wallet address
                                  //privateKey: this.decryptPrivateKey(privateKeyEncrypted), 
                                  privateKeyEncrypted: privateKeyEncrypted,
                                  profile: profile,
                                  profile_n: profile_n,
                                  pledge_pers: pledge_pers,
                                  userEmail_trim: this.props.userdetails[0].email,
                                  companyName: this.props.userdetails[0].companyName,
                                  firstName: this.props.userdetails[0].firstName,
                                  lastName: this.props.userdetails[0].lastName,
                                  userID: this.props.userdetails[0].userID,
                                  uid: this.props.userdetails[0].uid,
                                  companyID: this.props.userdetails[0].companyID,
                                  amount: 0, //$$ sent to buy coins
                                  amountS: 0,//sell MEV tokens
                                  func: 0, ////////////////////////////////// <===
                                  iBB: 28,//28,
                                  realpoints: 0,
                                  tokens: tokens,
                                  transBNB: '1.42',//'0.8123', //only for 3, 4, 7, 8, 9 & 10
                                  transMEV: '1941.46', //only for 9 & 10
                                  newMaxInBNB: 200, // for 11
                                  setPrice: 0.2547477016335612606102,//0.1544509231664636047248,  //only for 1
                                  transHash: '0xb6a9aa4e7cc2ffd77ac60d921fb13430261fe62e56a7a042bd4397d2058708de', //execute owner function after time delay 12, 15, 17
                                  minTrans: "0.00000001", //for 14
                                  newSafeWalletAddress: "0xBC29BB00739724Be72E3d0e81bBBe0DCCfe1Ff26", //only for 20
                                  withdrawAddress: '', //for 16
                                  NEW_WALLET: "0x633Fbb79475344677aDD287AE1474d705535d667",
                                  anywallet: "0xd0407B4BCB4A2D43F16D05F1bd53e00dcD275c7e",
                                  sendToCustodial: false,
                                  custodialwallet: "",
                                  divfact: 0, //circulatingTokenLiquidityFactor
                                  deployCode: process.env.REACT_APP_DEPLOYMENTCODE,
                                  captchaToken: captchaToken,
                                }
                          //});
                        }, {
                          headers: {
                              Authorization: `Bearer ${idToken}` // 🔒 Send the token in the header
                          }
                        });
                        
                        
                      }
                        ///////////////////////////////////////////////////////////////////////
                          
                          // Reset the loading state to false after the process is complete
                          // this.setState({ isBuying: false });
                        // //////////////////////////////////////////////////////////////////////////////////                 
                            // const bnbSentTransactionHash = res.data.bnbSentTransactionHash
                            // const amountOfCoinsPurchased = res.data.amountOfCoinsPurchased
                            // const totalGasFeesInUSD = res.data.totalGasFeesInUSD // Display gas fees in MEV tokens
                            // const mevInWallet = res.data.mevInWallet // Display MEV tokens in user wallet
                            // const mevCoinPriceInUSD = res.data.mevCoinPriceInUSD
                           
                            ////////////////////////////////////////////////////////////////////////   
                            //window.location.reload();
                            ////////////////////////////////////////////////////////////////////////
                       
                        // try {
                        //   let paramsX = {
                        //     type: SHOW_TOAST,
                        //     open: true,
                        //     variant: 'success',
                        //     message: 'You have purchased ' + amountOfCoinsPurchased + ' MEV coins successfully.'
                        //   }
                        //   this.props.showToast(paramsX)
                        //   //////////////////////////////////////////////////////////////////////////////////
                        //   await new Promise(resolve => setTimeout(resolve, 3000));  
                        //   ////////////////////////////////////////////////////////////////////////   
                        //     window.location.reload();
                        //   ////////////////////////////////////////////////////////////////////////
                    
                        // } catch (error) {
                        //   //this.setState({ isBuying: false });
                        // }
  
                      } catch (error) {
                          
                          // this.setState({ isBuying: false });
                          // Reset the loading state to false if an error occurs
                          //this.setState({ isBuying: false });
                      }
                  }
              }
          }
      }
    }

  buyCredits = async (MEVamount) => {
    const { captchaToken, AllowToSell } = this.state;

      const updates = {};
      var userLC;
      const myUid = this.props.userdetails[0].uid;
      var points = await this.getLivePoints(myUid); //this.props.userdetails[0].points;
      var tokens = await this.getLiveTokens(myUid); 
         console.log('Test-points S:', points);
   
      //Set session flag to prevent further execution
      var enoughPoints = points / 100;
      
      userLC = MEVamount;//parseInt(this.props.userdetails[0].points || 1); // only points and not calf points because calf alone could be more than 2, and it remains after rollover      

      if ((userLC < AllowToSell) && (enoughPoints > 2) && (userLC > 0)) {
          var newPayBool = true;
          var timeNow;
          var profile;
          var profile_n = this.props.userdetails[0].userType;
          var pledge_pers;
          var userID = this.props.userdetails[0].userID;
          var uid = this.props.userdetails[0].uid;
          var companyID = this.props.userdetails[0].companyID;
          var userwalletaddress = this.props.userdetails[0].wallet;
          var newWallet = false;
          var walletAddress;
          var privateKey;
          var privateKeyEncrypted;
          var WalletKeys;
  
         // timeNow = new Date();
         // GET SERVER TIME (UNHACKABLE)
          // const db = firebase.database;
          // const offsetRef = db.ref('.info/serverTimeOffset');
          // const snap = await offsetRef.once('value');
          // const offset = snap.val() || 0;
          // timeNow = new Date(Date.now() + offset);
         try {
          const ress = await axios.post(`${FB_URL}/m122-centraltime`, {});

          if (ress.data?.success === true && typeof ress.data.timestamp === 'number') {
            timeNow = new Date(res.data.timestamp);
            // Optional: verify it's recent
            const ageMs = Date.now() - timeNow.getTime();
            if (Math.abs(ageMs) > 30000) { // more than 30 seconds old → suspicious
              console.warn("Central time seems stale", ageMs);
            }
          } else {
            console.warn("Failed to get central time", ress.data);
            // Fallback strategy: use moment locally (less secure but better than nothing)
            timeNow = moment().tz("Africa/Johannesburg").toDate();
          }
          } catch (err) {
            console.error("Central time fetch failed:", err);
            // Fallback
            timeNow = moment().tz("Africa/Johannesburg").toDate();
          }            

          if (profile_n === 8 || profile_n === "8" || profile_n === '8') {
              profile_n = 3;
              profile = 'Public Contributor';
          } else {
              profile_n = this.props.userdetails[0].userType;
              profile = this.props.userdetails[0].userDescription;
          }
          
  
          if (newPayBool === true) {
              pledge_pers = userLC;
              
              if (userwalletaddress) {
                  // wallet already exists
                  newWallet = false;
              } else {
                  newWallet = true;
                  try {
                    ///////////MAKE WALLET/////////////////////
                    WalletKeys = await this.MakeWallet();
                    ///////////////////////////////////////////
                  } catch (error) {
                    
                    // Handle error appropriately
                  }
  
                  if (WalletKeys) {
    
                    walletAddress = WalletKeys.NewWalletAddress;
                    privateKeyEncrypted = WalletKeys.PrivateKey;
    
                    
                  } else {
                    
                  }
  
              }
              
            if (newWallet===false) {
              walletAddress = this.props.userdetails[0].wallet; //STILL HAVE TO TEST IF IT ARRIVES IN TIME
              privateKeyEncrypted = this.props.userdetails[0].privateKey;
              
  
            }

              if (walletAddress && privateKeyEncrypted && (newWallet = true)) {

                
                  if (pledge_pers < AllowToSell) {
                  
                      var semiFinalAmount = pledge_pers;// - 200; //subtract to accomidate gas fees
                      // var finalAmount = (Number(semiFinalAmount) / 100);
                      var finalAmount = semiFinalAmount;//semiFinalAmount / 100;
                      var finalPoints = (points - 200) / 100;

                    console.log('Test-points A:', pledge_pers);
                    console.log('Test-points B:', points);
                    console.log('Test-points C:', finalPoints);

                      try {
                        const auth = getAuth(); // Firebase Authentication instance
  
                        const user = auth.currentUser;
                        if (!user) {
                            
                            return;
                        }

                        // Get Firebase ID Token
                        const idToken = await user.getIdToken();
                        
                      // 1=reset MEV price/MEV liquidity; 
                      // 2=move various BNB/MEV; 
                      // 3=Transfer BNB from WALLETA to WALLETB; 
                      // 4=Transfer BNB from WALLETB to WALLETA
                      // 18=Transfer BNB from WALLETB to WALLETC
                      // 5=buyTokens
                      // 6=sellTokens
                      // 7=Transfer BNB from WALLETA to OWNER WALLET
                      // 8=Transfer BNB from OWNER WALLET to anywallet
                      // 9=Transfer BNB and MEV from sale contract to OWNER WALLET
                      // 10=Transfer BNB and MEV from OLD sale contract to OWNER WALLET
                      // 11=set MAX TRANSACTION AMOUNT for sale contract USING TIME DELAY OF 3 HOURS
                      // 12=UPDATE MAX TRANSACTION AMOUNT for sale contract ONLY
  
                      // 14=UPDATE MIN TRANSACTION AMOUNT ONLY wait   
                      // 15=execute MIN TRANSACTION AMOUNT ONLY
                      // 16=emergencyWithdraw
                      // 17=execute emergencyWithdraw
                      // 19=update WhitelistedSigner
                      // 20=newSafeWalletAddress
                      // 21=Transfer BNB from WALLETA to new whitelisted signer
                      // 22=Transfer BNB from WALLETC to WALLETA
                      // 23=Transfer BNB from WALLETA to any wallet
                      // 24=Transfer BNB from userWallet to any wallet
                        /////////////////////////////////////////
                        const buy_sell = true;//////////
                        /////////////////////////////////
                        let res;
                        if (buy_sell===true) {
                        //only BUY and SELL tokens//////////////////////////////////////////////////////
                        res = await axios.post(`${FB_URL}/m108-buymevision`, {
                        //  const res = await axios.post(`http://localhost:8597/m108-buymevision`, {
                              params: {
                                  wallet: walletAddress, //user wallet address
                                 // privateKey: this.decryptPrivateKey(privateKeyEncrypted), 
                                  privateKeyEncrypted: privateKeyEncrypted,
                                  profile: profile,
                                  profile_n: profile_n,
                                  pledge_pers: pledge_pers,
                                  userEmail_trim: this.props.userdetails[0].email,
                                  companyName: this.props.userdetails[0].companyName,
                                  firstName: this.props.userdetails[0].firstName,
                                  lastName: this.props.userdetails[0].lastName,
                                  userID: this.props.userdetails[0].userID,
                                  uid: this.props.userdetails[0].uid,
                                  companyID: this.props.userdetails[0].companyID,
                                  amount: 0, //$$ sent to buy coins
                                  amountS: finalAmount,//sell MEV tokens
                                  func: 26,// 6 - sell tokens / 5 - buy tokens / 26 - buy Credits 
                                  iBB: 28,//28,
                                  realpoints: finalPoints,
                                  tokens: tokens,
                                  leftoverLc: 0,
                                  transBNB: 0.2,
                                  transMEV: 0, 
                                  setPrice: 0,
                                  sendToCustodial: false, //this.state.sendToCustodial,
                                  custodialwallet: this.props.userdetails[0].custodialwallet,
                                  divfact: 0, //circulatingTokenLiquidityFactor - deviding factor that determines how MEV in circulation is considered by liquidity
                                  deployCode: process.env.REACT_APP_DEPLOYMENTCODE,
                                  captchaToken: captchaToken,
                                }
                          //});
                        }, {
                          headers: {
                              Authorization: `Bearer ${idToken}` // 🔒 Send the token in the header
                          }
                        });
                          
                         //send BNB to custodialwallet if option was selected
                        
                        // if (this.state.sendToCustodial===true) {
                        //  const bnbInWallet = this.props.userdetails[0].bnbInWallet;
                        //  const custodialwallet = this.props.userdetails[0].custodialwallet;
                        //  await new Promise(resolve => setTimeout(resolve, 5000));  
                        //  await this.SendBNBtoExternalExchange(bnbInWallet, custodialwallet);
                       
                        // }
                    /////////////////////////////////////////////////////////////////////////////
                      }
                      else
                      {

                    res = await axios.post(`${FB_URL}/m108-buymevision`, {
                              params: {
                                  wallet: walletAddress, //user wallet address
                                  //privateKey: this.decryptPrivateKey(privateKeyEncrypted), 
                                  privateKeyEncrypted: privateKeyEncrypted,
                                  profile: profile,
                                  profile_n: profile_n,
                                  pledge_pers: pledge_pers,
                                  userEmail_trim: this.props.userdetails[0].email,
                                  companyName: this.props.userdetails[0].companyName,
                                  firstName: this.props.userdetails[0].firstName,
                                  lastName: this.props.userdetails[0].lastName,
                                  userID: this.props.userdetails[0].userID,
                                  uid: this.props.userdetails[0].uid,
                                  companyID: this.props.userdetails[0].companyID,
                                  amount: 0, //$$ sent to buy coins
                                  amountS: 0,//sell MEV tokens
                                  func: 0, ////////////////////////////////// <===
                                  iBB: 28,//28,
                                  realpoints: 0,
                                  tokens: tokens,
                                  transBNB: '1.42',//'0.8123', //only for 3, 4, 7, 8, 9 & 10
                                  transMEV: '1941.46', //only for 9 & 10
                                  newMaxInBNB: 200, // for 11
                                  setPrice: 0.2547477016335612606102,//0.1544509231664636047248,  //only for 1
                                  transHash: '0xb6a9aa4e7cc2ffd77ac60d921fb13430261fe62e56a7a042bd4397d2058708de', //execute owner function after time delay 12, 15, 17
                                  minTrans: "0.00000001", //for 14
                                  newSafeWalletAddress: "0xBC29BB00739724Be72E3d0e81bBBe0DCCfe1Ff26", //only for 20
                                  withdrawAddress: '', //for 16
                                  NEW_WALLET: "0x633Fbb79475344677aDD287AE1474d705535d667",
                                  anywallet: "0xd0407B4BCB4A2D43F16D05F1bd53e00dcD275c7e",
                                  sendToCustodial: false,
                                  custodialwallet: "",
                                  divfact: 0, //circulatingTokenLiquidityFactor
                                  deployCode: process.env.REACT_APP_DEPLOYMENTCODE,
                                  captchaToken: captchaToken,
                                }
                          //});
                        }, {
                          headers: {
                              Authorization: `Bearer ${idToken}` // 🔒 Send the token in the header
                          }
                        });
                        
                        
                      }
                        ///////////////////////////////////////////////////////////////////////
                          
                          // Reset the loading state to false after the process is complete
                          // this.setState({ isBuying: false });
                        // //////////////////////////////////////////////////////////////////////////////////                 
                            // const bnbSentTransactionHash = res.data.bnbSentTransactionHash
                            // const amountOfCoinsPurchased = res.data.amountOfCoinsPurchased
                            // const totalGasFeesInUSD = res.data.totalGasFeesInUSD // Display gas fees in MEV tokens
                            // const mevInWallet = res.data.mevInWallet // Display MEV tokens in user wallet
                            // const mevCoinPriceInUSD = res.data.mevCoinPriceInUSD
                           
                            ////////////////////////////////////////////////////////////////////////   
                            //window.location.reload();
                            ////////////////////////////////////////////////////////////////////////
                       
                        // try {
                        //   let paramsX = {
                        //     type: SHOW_TOAST,
                        //     open: true,
                        //     variant: 'success',
                        //     message: 'You have purchased ' + amountOfCoinsPurchased + ' MEV coins successfully.'
                        //   }
                        //   this.props.showToast(paramsX)
                        //   //////////////////////////////////////////////////////////////////////////////////
                        //   await new Promise(resolve => setTimeout(resolve, 3000));  
                        //   ////////////////////////////////////////////////////////////////////////   
                        //     window.location.reload();
                        //   ////////////////////////////////////////////////////////////////////////
                    
                        // } catch (error) {
                        //   //this.setState({ isBuying: false });
                        // }
  
                      } catch (error) {
                          
                          // this.setState({ isBuying: false });
                          // Reset the loading state to false if an error occurs
                          //this.setState({ isBuying: false });
                      }
                  }
              }
          }
      }
    }

    handleCheckboxChange = async () => {
      this.setState(prevState => ({
        sendToCustodial: !prevState.sendToCustodial
      }));
    }

  render() {
    const { modalOpen, modalAOpen, modalTOpen, mevAmount, LcAmount, sellApproved, siteKey } = this.state;
    const { classes, userdetails } = this.props;
    const userLCReady = parseInt(userdetails[0]?.points || 1);
    const LcInUSD = Number(userLCReady / 100);

    if (this.buyApproved === null) {
      return <div>Loading transaction feasibility...</div>;
    }
     //////////////////////////////////////////////////////////////////
      const approvedEmails = [
        'levissindiga@gmail.com',
        'christinekalondu83@gmail.com',
        'bryan@artibeus.com',
        'watkinsdoreen742@gmail.com',
        'viljoen31@gmail.com',
        'angus@belztrading.co.za',
        'zjhardware2010@gmail.com',
        'conradmoller@outlook.com',
        'xolile@salubedist.co.za',
        'johanbester55@gmail.com',
        'maletjile@gmail.com',
        'alhajmelamu@gmail.com',
        'adriaan@leadershipplatform.com',
        'christo@tle.global',
        'mychristo@gmail.com',
        'elmarie227@gmail.com',
        'louis@leadershipplatform.com',
        'thwalabuyi19@gmail.com',
        'ebehmichaeltochukwu@gmail.com',
        'mnyoka777@gmail.com',
        'martin@martincrous.com',
        'ebehcomfortugo@gmail.com',
      ];

      const specialPatron = approvedEmails.includes(
        userdetails[0].email?.toLowerCase()
      );
     ////////////////////////////////////////////////////////////////////
     console.log('buyApproved boolen: ', this.buyApproved);
    // console.log('userdetails : ', userdetails[0]);
    return (
      <div className={classes.root}>
        {this.state.errorMessage && (
          <Typography color="error" align="center">
            Error: {this.state.errorMessage}
          </Typography>
        )}
        <Typography variant="h4" component="h1" gutterBottom>
          MEV Exchange
        </Typography>
         {/* <div style={{
            justifyContent: 'center',
            color: 'orange'
          }}>
         <span> Our exchange is closed temporarily for a few days. We will be back soon. Thank you for your patience. </span>
         </div> */}
       {/* TOTP (Google Authenticator) Verification Required Section */}            
      {/*      {LcInUSD===20.888 ? (         */}
      
       {this.state.whatsappOTPRequired && !this.state.isWhatsAppVerified ? (    
         <Box display="flex" flexDirection="column" alignItems="center" mb={4} mt={4}>
            {!this.state.totpEnabled ? (
              <div style={{
                backgroundColor: '#fff3cd',
                padding: '24px',
                borderRadius: '12px',
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                maxWidth: '480px',
                width: '100%',
                border: '2px solid #ffc107'
              }}>
                <Typography variant="h6" style={{ color: '#856404', marginBottom: '10px', fontWeight: 'bold' }}>
                  🔒 Google Authenticator Required
                </Typography>
                <Typography variant="body2" style={{ color: '#856404', marginBottom: '10px' }}>
                  To protect your MEV Exchange, you must first enable Google Authenticator (TOTP) in your Security settings.
                </Typography>
                <Typography variant="body2" style={{ color: '#856404' }}>
                  Go to your profile → Security tab, enable TOTP, then return here to enter your code.
                </Typography>
              </div>
            ) : (
              <div style={{
                backgroundColor: '#e3f2fd',
                padding: '24px',
                borderRadius: '12px',
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                maxWidth: '480px',
                width: '100%',
                border: '2px solid #2196f3'
              }}>
                <Typography variant="h6" style={{ color: '#0d47a1', marginBottom: '8px', fontWeight: 'bold' }}>
                  🔐 Verify Your Identity
                </Typography>
                <Typography variant="body2" style={{ color: '#0d47a1', marginBottom: '16px' }}>
                  Enter the current code from Google Authenticator to access the MEV Exchange.
                </Typography>
                <TextField
                  fullWidth
                  label="Enter 6-digit TOTP Code"
                  value={this.state.mevOTPCode}
                  onChange={this.handleMevTOTPChange}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' && this.state.mevOTPCode.length === 6 && !this.state.isVerifyingMevOTP) {
                      this.handleVerifyMevTOTP();
                    }
                  }}
                  inputProps={{
                    maxLength: 6,
                    style: {
                      fontSize: '24px',
                      letterSpacing: '8px',
                      textAlign: 'center',
                      fontWeight: 'bold'
                    }
                  }}
                  placeholder="000000"
                  style={{ marginBottom: '15px' }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={this.handleVerifyMevTOTP}
                  disabled={this.state.mevOTPCode.length !== 6 || this.state.isVerifyingMevOTP}
                  style={{
                    padding: '12px',
                    fontWeight: 'bold'
                  }}
                >
                  {this.state.isVerifyingMevOTP ? 'Verifying...' : 'VERIFY & ACCESS EXCHANGE'}
                </Button>
              </div>
            )}
          </Box>
        ) : (
          // Show BUY/SELL buttons only after TOTP verification
        <Box 
          display="flex" 
          justifyContent="center" 
          alignItems="center"
          gap={2}           // This is the best way - consistent spacing
          mb={2}
          flexWrap="wrap"   // Optional: good for mobile
        >
          {/* Buy Button */}
          {(userLCReady > 600 && this.buyApproved) ? (
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              style={{ borderRadius: '50px' }}
              onClick={() => this.handleOpenAModal()}
            >
              Buy MEV
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              style={{ borderRadius: '50px' }}
              disabled
            >
              Buy MEV
            </Button>
          )}

          {/* Sell Button */}
          {/* {(userLCReady > 200) ? (
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              style={{ borderRadius: '50px' }}
              onClick={() => this.handleOpenModal()}
            >
              Sell
            </Button>
          ) : (
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              style={{ borderRadius: '50px' }}
              disabled
            >
              Sell
            </Button>
          )} */}

        {/* Sell Button */}
        {specialPatron && (
          userLCReady > 200 ? (
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              style={{ borderRadius: '50px' }}
              onClick={() => this.handleOpenModal()}
            >
              Sell MEV
            </Button>
          ) : (
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              style={{ borderRadius: '50px' }}
              disabled
            >
              Sell MEV
            </Button>
          )
        )}

          {/* Buy Tokens Button */}
          {(userLCReady > 200) ? (
          <Button
            variant="contained"
            color="success"           // Best way in MUI v5+
            className={classes.button}
            style={{ borderRadius: '50px' }}
            onClick={() => this.handleOpenTModal()}
          >
            Buy Tokens
          </Button>
          ) : (
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              style={{ borderRadius: '50px' }}
              disabled
            >
              Buy Tokens
            </Button>
          )}
        </Box>
        )}

        {this.state.showProgress && (
        <div style={{ width: '100%', margin: '10px 0', overflow: 'visible' }}>
          {this.state.showProgress ? (
            <LinearProgress
              variant="determinate"
              value={this.state.progress}
              classes={{ root: classes.progress }}
            />
          ) : (
            <div>Loading progress...</div>
          )}
        </div>
        )}
        <Typography variant="body1" align="center" gutterBottom>
        <div style={{ color: '#babad6'}}>
          {/* We are developing the MEV sell process. Watch this space for updates. */}
          { this.state.mevnote}
          </div>
        </Typography> 

        {/* Modal for MEV Amount Input to SELL*/}
        <Modal open={modalOpen} onClose={this.handleCloseModal}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: { xs: '90%', sm: 400 }, // Responsive width: 90% on mobile, 400px on larger screens
              maxWidth: '100%', // Prevent overflow on small screens
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center', // Center content horizontally
              minHeight: 250, // Ensure enough height for content
            }}
          >
            <Typography
              variant="h6"
              sx={{
                textAlign: 'center',
                width: '100%',
                mb: 2, // Margin bottom for spacing
              }}
            >
              Sell MEV
            </Typography>
            <TextField
              label="Amount MEV"
              value={mevAmount}
              onChange={this.handleAmountChange}
              type="number"
              fullWidth
              margin="normal"
              sx={{ mb: 3 }} // Extra margin for spacing
            />
       <div>
        {this.props.userdetails && this.props.userdetails.length > 0 && 
        this.props.userdetails[0]?.custodialwallet && 
        typeof this.props.userdetails[0].custodialwallet === 'string' && 
        this.props.userdetails[0].custodialwallet.length > 0 ? (
          <label style={{ color: '#5d6d7e' }}>
            <input
              type="checkbox"
              checked={this.state.sendToCustodial}
              onChange={this.handleCheckboxChange}
            />
            &nbsp;Send all payouts directly to Custodial Wallet
          </label>
        ) : null}
      </div>
      <div>&nbsp;</div>
    {/* Add CAPTCHA here */}
    <ReCAPTCHA
      sitekey={siteKey} 
      onChange={this.handleCaptchaChange}
      onExpired={this.handleCaptchaExpired}
      style={{ marginTop: 16, marginBottom: 16 }}  // Optional styling
    />
            <Button
              variant="contained"
              sx={{
                bgcolor: 'red', // Red background
                color: 'white', // White text for contrast
                '&:hover': { bgcolor: '#cc0000' }, // Slightly darker red on hover
                mt: 'auto', // Push button to bottom
                width: 'fit-content', // Button width based on content
              }}
              onClick={this.handleSellMEV}
            >
              Sell MEV
            </Button>     

          </Box>
        </Modal>

       {/* Modal to BUY MEV */}
        <Modal open={modalAOpen} onClose={this.handleCloseAModal}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
            }}
          >
            <Typography variant="h6" gutterBottom>
              Buy MEV
            </Typography>
            <TextField
              label="Amount Lc"
              value={LcAmount}
              onChange={this.handleAmountAChange}
              type="number"
              fullWidth
              margin="normal"
            />
    {/* Add CAPTCHA here */}
    <ReCAPTCHA
      sitekey={siteKey} 
      onChange={this.handleCaptchaChange}
      onExpired={this.handleCaptchaExpired}
      style={{ marginTop: 16, marginBottom: 16 }}  // Optional styling
    />
            <Button
              variant="contained"
              color="primary"
             // onClick={this.handleSellMEV}
              onClick={this.handleBuyMEV}
              style={{ marginTop: 16 }}
            >
              Buy MEV
            </Button>
          </Box>
        </Modal>

        {/* Modal for buying Tokens */}
        <Modal open={modalTOpen} onClose={this.handleCloseTModal}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: { xs: '90%', sm: 400 }, // Responsive width: 90% on mobile, 400px on larger screens
              maxWidth: '100%', // Prevent overflow on small screens
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center', // Center content horizontally
              minHeight: 250, // Ensure enough height for content
            }}
          >
            <Typography
              variant="h6"
              sx={{
                textAlign: 'center',
                width: '100%',
                mb: 2, // Margin bottom for spacing
              }}
            >
              Buy Tokens
            </Typography>
            <TextField
              label="Amount MEV"
              value={mevAmount}
              onChange={this.handleAmountChange}
              type="number"
              fullWidth
              margin="normal"
              sx={{ mb: 3 }} // Extra margin for spacing
            />
       {/* <div>
        {this.props.userdetails && this.props.userdetails.length > 0 && 
        this.props.userdetails[0]?.custodialwallet && 
        typeof this.props.userdetails[0].custodialwallet === 'string' && 
        this.props.userdetails[0].custodialwallet.length > 0 ? (
          <label style={{ color: '#5d6d7e' }}>
            <input
              type="checkbox"
              checked={this.state.sendToCustodial}
              onChange={this.handleCheckboxChange}
            />
            &nbsp;Send all payouts directly to Custodial Wallet
          </label>
        ) : null}
      </div> */}
      <div>&nbsp;</div>
    {/* Add CAPTCHA here */}
    <ReCAPTCHA
      sitekey={siteKey} 
      onChange={this.handleCaptchaChange}
      onExpired={this.handleCaptchaExpired}
      style={{ marginTop: 16, marginBottom: 16 }}  // Optional styling
    />
            <Button
              variant="contained"
              sx={{
                bgcolor: 'yello', // Red background
                color: 'white', // White text for contrast
                '&:hover': { bgcolor: '#cc0000' }, // Slightly darker red on hover
                mt: 'auto', // Push button to bottom
                width: 'fit-content', // Button width based on content
              }}
              onClick={this.handleBuyTokens}
            >
              Buy Tokens
            </Button>
       
          </Box>
        </Modal>

      </div>
    );
  }
}
const MevcoinExchange = withStyles(styles)(Mevcoin);

const mapStateToProps = (state) => ({
  userdetails: state.userDialog.userDetails,
});
const mapDispatchToProps = (dispatch) => {
  return {
    showToast: params => dispatch(showToast(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MevcoinExchange)
//export default withStyles(styles)(connect(mapStateToProps)(Mevcoin));